import React, { lazy, useEffect, useState, useContext, useRef } from "react";
import { FlexColumn, FlexRow, Spacer, SLNotification } from "../../components/core/utility";
import { Loader } from "@vds/loaders";
import { css } from "@emotion/react";
import styled from "styled-components";
import { Button, TextLink } from "@vds/buttons";
import { generate } from "shortid";
import useOutsideClick from "../../customHook/use-outside-click";
import { CREATE_WORK_TICKET_LIST_COLS } from "../../constants/CreateWorkTicketConstants";
import { WTACreateWorkTicketGrid } from "./WTACreateWorkTicketGrid";
import { getCreateAllWTTransactionStatus } from "../../services/C4S Decommission - Replacement/getCreateAllWTTransactionStatus";
import { OrderShippingSummaryAccordion } from "./OrderShippingSummaryAccordion";
import { bundleList } from "../../services/C4S Decommission - Replacement/bundleList";
import { ViewVehicleList } from "../../services/C4S Decommission - Replacement/viewVehicleList";
import { addJobNew } from "../../services/scheduler/addJob";
import { getSchedule } from "../../services/scheduler/getSchedule";
import { getSlots } from "../../services/scheduler/getSlots";
import { CreateWorkTicketAuto } from "../../services/C4S Decommission - Replacement/createWorkTicketAuto";
import { CreateWorkTicketSingle } from "../../services/C4S Decommission - Replacement/createWorkTicketSingle";
import { updateNewrelicStats } from "../../../utility/newrelic";
import { ATPCheck } from "../../services/C4S Decommission - Replacement/ATPCheck";
import { C4SContext } from "../../context/c4sContext";
import { groupBy } from "lodash";
import moment from "moment";
import { getExchangeCode } from "../../../constants/ProcessingCodeConstants";
import { useUnitPriceMap } from "../../customHook/useUnitPriceMap";
import { getChargePrice as getChargePriceUtil } from "../../utility/priceUtils";
import { switchTab } from "../../pages/C4S Decommission - Replacement/utils";
import WorkTicketsSuccessModal from "./WorkTicketsSuccessModal";
import NoSlotsAvailableModal from "./NoSlotsAvailableModal";
import { CircularProgressbar } from "react-circular-progressbar";
import { addPage } from "../../../utility/navigation";
import { AlternateManualEntryMetadata } from "../../../C4S Decommission - Replacement/pages/OpenJobs/AlternateManualSchedule";

const IconWrapper = styled.div`
  :focus {
    border: none;
    outline: none;
    box-shadow: none;
  }
  height: 24px;
  width: 24px;
  align-items: center;
  cursor: pointer;
  margin-right: 10px;
  display: flex;
`;

export const CustomisedNotification = css`
  & span:last-child {
    max-width: fit-content;
  }
`;

const customSpinner = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0.8;
  background: rgba(255, 255, 255, 0.6);
  & svg {
    width: 6%;
  }
  .CircularProgressbar-path {
    stroke: green;
  }
  .CircularProgressbar-text {
    fill: #000000;
    font-size: 25px;
    font-weight: bold;
  }
`;

const CreateWorkticket = (props) => {
  let productData = groupBy(props?.cspData?.data?.data?.Product, "BundleId");
  let spinnerPercentage;
  const [spinner, setSpinner] = useState(false);
  const [spinnerValue, setSpinnerValue] = useState(0);
  const [kbArticleLink] = useState("https://vzt-kb.vtitel.com/Reveal/Reveal_Support/Reveal_Scheduling/Scheduling_and_Shipping_Scenarios");
  const [cspDetailsData] = useState(Object.keys(productData));
  const cspSessionData = props?.cspData?.data?.data || JSON.parse(sessionStorage.getItem("CSPDetails"));
  const salesOrgId = cspSessionData?.CSP?.length ? cspSessionData?.CSP.filter((csp) => csp.DefaultCSP === "1")[0].Opp_Sales_Org : "";
  const providerOrder = cspSessionData?.CSP[0].Provider_Order || "";
  const isWTA = sessionStorage.getItem("isWTA") === "true";

  const { notification, isSourceCSP } = useContext(C4SContext);

  // Create unitPrice map using shared custom hook
  const unitPriceMap = useUnitPriceMap(props?.cspData?.data?.data?.Product);

  // Helper function to get charge price based on conditions
  const getChargePrice = (techRefId, chargePrice, processingCode) => {
    return getChargePriceUtil(techRefId, chargePrice, processingCode, unitPriceMap, isSourceCSP.isSourceCSP);
  };

  const [loader, setLoader] = useState(true);
  const [vehiclesHeaderData, setVehiclesHeaderData] = useState([]);
  const [allVehicleList, setAllVehicleList] = useState([]);

  const [updatedVehicles, setUpdatedVehicles] = useState([]);
  const [bundleCount, setBundleCount] = useState(0);
  const [transactionId, setTransactionId] = useState("");
  const [orderNumber, setOrderNumber] = useState(cspSessionData?.CSP?.[0]?.CRM_Ref_ID || "");
  const [createWorkTicketValidVehiclesOrAssetsButtonStatus, setCreateWorkTicketValidVehiclesOrAssetsButtonStatus] = useState(true);
  const [createWorkTicketProgress, setCreateWorkTicketProgress] = useState(false);
  const [transactionOrderStatus, setTransactionOrderStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAtpCheck, setIsAtpCheck] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState(null);
  const isApiCallInProgress = useRef(false);
  const isSingleApiCallInProgress = useRef(false);
  const removalCriteriaRef = useRef(null); // holds row removal criteria after WT creation
  const [showWTModal, setShowWTModal] = useState(false);
  const [wtSuccessNumbers, setWtSuccessNumbers] = useState([]);
  const [showNoSlotsDialog, setShowNoSlotsDialog] = useState(false);
  const noSlotsJobDataRef = useRef(null);

  const refreshPage = async (transactionOrderStatus = false) => {
    if (transactionOrderStatus === true) {
      setCreateWorkTicketValidVehiclesOrAssetsButtonStatus(false);
      setCreateWorkTicketProgress(true);
      setUpdatedVehicles([]);
      setIsDataLoaded(false);
      setLoader(false);
    } else {
      setCreateWorkTicketValidVehiclesOrAssetsButtonStatus(true);
      setCreateWorkTicketProgress(false);
      await fetchHeaderList();
    }
  };

  useEffect(() => {
    getWTTransactionStatus(orderNumber, transactionId || "");
  }, []);

  const getWTTransactionStatus = async (ordNo, transId) => {
    try {
      let response = await getCreateAllWTTransactionStatus(ordNo, transId);
      if (response?.data?.statusCode === "200" && response?.data) {
        let orderStatusData = response?.data?.data;
        let hasInProgress = false;
        setTransactionId(orderStatusData?.TransactionId);
        if (!orderStatusData || !Array.isArray(orderStatusData) || orderStatusData === null) {
          setTransactionOrderStatus(false);
        } else {
          if (Array.isArray(orderStatusData)) {
            hasInProgress = orderStatusData.some((order) => order.OrderStatus === "IN_PROGRESS");
            setTransactionOrderStatus(hasInProgress);
          } else {
            setTransactionOrderStatus(false);
            hasInProgress = false;
          }
        }
        refreshPage(hasInProgress);
      } else {
        setLoader(false);
        notify("Error occurred while fetching order transaction data. Please try again", "error", false);
      }
    } catch (error) {
      setLoader(false);
      notify("Error checking transaction order status:", "error", false);
    }
  };

  const fetchHeaderList = async () => {
    setLoader(true);
    setIsDataLoaded(false);
    let response = await bundleList(cspDetailsData, props?.AccountID, props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID);
    if (response?.data?.statusCode === "200" && response?.data) {
      let bundleHeaderList = response?.data?.data.bundles;
      setVehiclesHeaderData(bundleHeaderList);
      callViewVehicleListAPI(bundleHeaderList)
        .then((responses) => {
          const vehicleListByBundleId = mergeAllDataArrays(responses);
          setAllVehicleList(vehicleListByBundleId);
          const summary = getUniqueAddressContractSummary(bundleHeaderList, vehicleListByBundleId);
          // Apply deferred removal if criteria exists
          if (removalCriteriaRef.current) {
            const { addressId, contactId, lineType, workTicketId } = removalCriteriaRef.current;
            const normalizedLineType = lineType ?? null;
            const normalizedWorkTicketId = workTicketId ?? null;
            const filtered = summary.filter((row) => {
              const sameLineType = (row.lineType ?? null) === normalizedLineType;
              const sameWorkTicketId = (row.workTicketId ?? null) === normalizedWorkTicketId;
              return !(
                String(row.addressId) === String(addressId) &&
                String(row.contactId) === String(contactId) &&
                sameLineType &&
                sameWorkTicketId
              );
            });
            setUpdatedVehicles(filtered);
            removalCriteriaRef.current = null; // clear criteria after applying
          } else {
            setUpdatedVehicles(summary);
          }
          setIsDataLoaded(true);
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
          notify("Error occurred while fetching Vehicle List. Please try again", "error", false);
        });
    } else {
      setLoader(false);
      notify("Error occurred while fetching Vehicle List. Please try again", "error", false);
    }
  };

  const callViewVehicleListAPI = async (vehiclesHeaderData) => {
    const result = [];
    const uniqueCombinations = [];
    const uniqueKeys = new Set();

    vehiclesHeaderData.forEach((bundle) => {
      const { bundleId, vehicle, shipGroups } = bundle;
      shipGroups.forEach((shipGroup) => {
        const { addressId, address, contactId, contactName, city, stateCode, countryCode, zipCode } = shipGroup;
        // Check if the combination of address and contactName already exists
        const existingEntry = result.find((entry) => entry.address === address && entry.contactName === contactName);

        if (existingEntry) {
          // If it exists, update the counts
          existingEntry.bundleIds = [...new Set([...existingEntry.bundleIds, bundleId])];
        } else {
          // If it doesn't exist, create a new entry
          result.push({
            bundleId: bundleId,
            addressId,
            contactId,
            city,
            stateCode,
            countryCode,
            zipCode,
          });
        }
      });
    });
    result.forEach((vehicle) => {
      const { bundleId, addressId, contactId } = vehicle;
      const key = `${bundleId}-${addressId}-${contactId}`;

      if (!uniqueKeys.has(key)) {
        uniqueKeys.add(key);
        uniqueCombinations.push({ bundleId, addressId, contactId });
      }
    });
    const completeVehiclesList = getCompleteVehicleList(uniqueCombinations);
    return completeVehiclesList;
  };

  const getCompleteVehicleList = async (uniqueCombinationsOfAddreess) => {
    // Call the ViewVehicleList API for each unique combination
    const completeVehiclesArray = await Promise.all(
      uniqueCombinationsOfAddreess.map(async ({ bundleId, addressId, contactId, index }) => {
        try {
          const key = `${bundleId}-${addressId}-${contactId}`;
          const response = await ViewVehicleList(bundleId, addressId, contactId, cspSessionData?.CSP?.[0]?.CRM_Ref_ID || "", null, null, true);
          if (response.data?.data === null) {
            return { bundleId, addressId, contactId, data: [] };
          } else {
            return { bundleId, addressId, contactId, data: [response.data?.data] };
          }
        } catch (error) {
          return { bundleId, addressId, contactId, error, data: [] };
        }
      })
    );

    return completeVehiclesArray;
  };

  const mergeAllDataArrays = (inputArray) => {
    const mergedData = inputArray.reduce((acc, current) => {
      const key = `${current.bundleId}_${current.addressId}_${current.contactId}`;
      if (!acc[key]) {
        acc[key] = { bundleId: current.bundleId, addressId: current.addressId, contactId: current.contactId, data: [] };
      }
      acc[key].data.push(...current.data);
      return acc;
    }, {});
    return { data: [mergedData] };
  };

  /* istanbul ignore next */
  const countHardwareByBundle = (data, lineType = null, workTicketId = null) => {
    const result = {};
    const vehicles = data.vehicles;

    Object.keys(vehicles).forEach((bundleId) => {
      if (!result[bundleId]) {
        result[bundleId] = {};
      }

      vehicles[bundleId].forEach((vehicle) => {
        const isWarning = vehicle.vehicleStatus && vehicle.vehicleStatus.toLowerCase().includes("warning");
        if (isWarning) {
          return;
        }

        if (!vehicle.materialMapping || !Array.isArray(vehicle.materialMapping)) {
          return;
        }

        const uniqueHardwareIds = new Set();

        vehicle.materialMapping.forEach((mapping) => {
          const isEnabled = mapping.enabled !== false;
          const materialLineType = mapping.lineType;
          const materialWorkTicketId = mapping.workTicketId || null;
          const shouldInclude =
            lineType === null ? materialLineType === "Fulfill" || !materialLineType || materialLineType === "" : materialLineType === lineType;
          const workTicketMatches = workTicketId === null ? true : materialWorkTicketId === workTicketId;

          if (isEnabled && shouldInclude && workTicketMatches) {
            uniqueHardwareIds.add(mapping.hardwareId);
          }
        });

        // Process each unique hardwareId for the current vehicle
        uniqueHardwareIds.forEach((hardwareId) => {
          const materialsWithSameHardwareId = vehicle.materialMapping.filter((mapping) => {
            const isEnabled = mapping.enabled !== false;
            const materialLineType = mapping.lineType;
            const materialWorkTicketId = mapping.workTicketId || null;
            const shouldInclude =
              lineType === null ? materialLineType === "Fulfill" || !materialLineType || materialLineType === "" : materialLineType === lineType;
            const workTicketMatches = workTicketId === null ? true : materialWorkTicketId === workTicketId;
            return mapping.hardwareId === hardwareId && isEnabled && shouldInclude && workTicketMatches;
          });

          let selectedMaterial;
          if (materialsWithSameHardwareId.length > 1) {
            selectedMaterial = materialsWithSameHardwareId.find((mapping) => mapping.type === "Core");
            if (!selectedMaterial) {
              return;
            }
          } else {
            selectedMaterial = materialsWithSameHardwareId[0];
          }

          const { hardwareName, techRefId, type, quantity } = selectedMaterial;
          const { deviceType } = vehicle;
          if (!result[bundleId][hardwareId]) {
            result[bundleId][hardwareId] = {
              orderQuantity: 0,
              itemDescription: hardwareName,
              itemCode: hardwareId,
              techRefId: techRefId,
              type: type,
            };
          }

          if (deviceType === "KEYFOB" && typeof quantity === "number") {
            result[bundleId][hardwareId].orderQuantity += quantity;
          } else {
            result[bundleId][hardwareId].orderQuantity += 1;
          }
        });
      });
    });

    return result;
  };
  /* istanbul ignore next */
  const extractInnerObjects = (data) => {
    const result = [];

    Object.values(data).forEach((items) => {
      Object.values(items).forEach((innerObject) => {
        result.push(innerObject);
      });
    });

    return result;
  };

  const sumOrderQuantityForSameItemCode = (items) => {
    const groupedItems = {};

    items.forEach((item) => {
      const { itemCode, orderQuantity } = item;

      if (!groupedItems[itemCode]) {
        groupedItems[itemCode] = { ...item }; // Initialize the object for this itemCode
      } else {
        groupedItems[itemCode].orderQuantity += orderQuantity; // Sum the orderQuantity for the same itemCode
      }
    });

    return Object.values(groupedItems); // Convert groupedItems back to an array
  };

  const getMaterialAggregationKey = (materialId, techRefId, baseItemId, processingCode) => {
    return `${String(materialId ?? "")}|${String(techRefId ?? "")}|${String(baseItemId ?? "")}|${String(processingCode ?? "")}`;
  };

  const handleViewButtonClick = async (bundleId, addressId, contactId, lineType, selectedDeliveryDate, workTicketId = null) => {
    try {
      notification.setNotification(null);
      if (selectedDeliveryDate) {
        setSelectedDeliveryDate(selectedDeliveryDate);
      }
      const bundleIds = Array.isArray(bundleId) ? bundleId : [bundleId];

      const responseData = {
        vehicles: {},
      };

      let foundData = false;

      bundleIds.forEach((singleBundleId) => {
        const cacheKey = `${singleBundleId}_${addressId}_${contactId}`;
        const cachedData = allVehicleList?.data?.[0]?.[cacheKey];

        if (cachedData && cachedData.data.length > 0) {
          foundData = true;
          cachedData.data.forEach((dataItem) => {
            Object.entries(dataItem.vehicles).forEach(([vehicleBundleId, vehicleArray]) => {
              if (!responseData.vehicles[vehicleBundleId]) {
                responseData.vehicles[vehicleBundleId] = [];
              }
              responseData.vehicles[vehicleBundleId].push(...vehicleArray);
            });
          });
        }
      });

      if (foundData) {
        let hardwareDetails = [];
        hardwareDetails = extractInnerObjects(countHardwareByBundle(responseData, lineType, workTicketId));
        const combinedHardwares = sumOrderQuantityForSameItemCode(hardwareDetails);
        handleATPCheck(bundleId, addressId, contactId, combinedHardwares, [], lineType, selectedDeliveryDate, workTicketId);
      } else {
        notify("No vehicle data found. Please refresh the page and try again.", "error", false);
      }
    } catch (err) {
      notify("Error occurred while processing Vehicle data. Please try again", "error", false);
    }
  };

  /* istanbul ignore next */
  const displayATPData = (bundleId, addressId, contactId, hardwareDetails, lineType = null, workTicketId = null) => {
    const copiedUpdatedVehicles = updatedVehicles.map((vehicle) => ({ ...vehicle }));

    const bundleIdToMatch = Array.isArray(bundleId) ? bundleId[0] : bundleId;
    const normalizedLineType = lineType ?? null;
    const normalizedWorkTicketId = workTicketId ?? null;

    const selectedIndex = copiedUpdatedVehicles.findIndex((vehicle) => {
      const vehicleLineType = vehicle.lineType ?? null;
      const vehicleWorkTicketId = vehicle.workTicketId ?? null;
      return (
        vehicle.addressId === addressId &&
        vehicle.contactId === contactId &&
        vehicle.bundleIds.includes(bundleIdToMatch) &&
        vehicleLineType === normalizedLineType &&
        vehicleWorkTicketId === normalizedWorkTicketId
      );
    });

    if (selectedIndex !== -1) {
      copiedUpdatedVehicles[selectedIndex]["hardwareDetails"] = hardwareDetails;
      copiedUpdatedVehicles[selectedIndex]["viewButtonClicked"] = true;
    } else {
      //
    }
    setUpdatedVehicles([...copiedUpdatedVehicles]);
  };

  const removeAllMaterials = (vins) => {
    if (vins) {
      vins.forEach((vin) => {
        delete vin.allMaterials; // Remove the "allMaterials" key
      });
    }
    return vins;
  };

  const combineVinMaterialsRequest = (vinMaterialsRequest) => {
    const combinedRequest = [];

    vinMaterialsRequest.forEach((request) => {
      const requestLineType = request.lineType ?? null;
      const requestWorkTicketId = request.workTicketId ?? null;
      const existingEntry = combinedRequest.find((entry) => {
        const entryLineType = entry.lineType ?? null;
        const entryWorkTicketId = entry.workTicketId ?? null;
        return (
          entry.addressId === request.addressId &&
          entry.contactId === request.contactId &&
          entryLineType === requestLineType &&
          entryWorkTicketId === requestWorkTicketId
        );
      });

      if (existingEntry) {
        existingEntry.vins = [...existingEntry.vins, ...request.vins];
        existingEntry.materials = [...existingEntry.materials, ...request.materials];
      } else {
        combinedRequest.push({
          addressId: request.addressId,
          contactId: request.contactId,
          lineType: request.lineType,
          workTicketId: request.workTicketId,
          vins: [...request.vins],
          materials: [...request.materials],
        });
      }
    });

    return combinedRequest;
  };

  const generateVinMaterialsRequestAll = (vehiclesData, shipGroupData) => {
    const vinMaterialsRequest = [];
    const lineTypeWorkTicketCombinations = new Set();
    vehiclesData.forEach((vehicleGroup) => {
      Object.values(vehicleGroup).forEach((vehicleData) => {
        vehicleData.data.forEach((dataItem) => {
          Object.values(dataItem.vehicles).forEach((vehicleArray) => {
            vehicleArray.forEach((vehicle) => {
              if (vehicle.materialMapping && Array.isArray(vehicle.materialMapping)) {
                vehicle.materialMapping.forEach((material) => {
                  if (material.enabled !== false) {
                    const materialLineType = material.lineType;
                    const lineType = materialLineType === "Reship" ? "Reship" : null;
                    const workTicketId = material.workTicketId || null;
                    const key = `${lineType}|${workTicketId || ""}`;
                    lineTypeWorkTicketCombinations.add(key);
                  }
                });
              }
            });
          });
        });
      });
    });
    const combinationsToProcess = Array.from(lineTypeWorkTicketCombinations).map((key) => {
      const [lineType, workTicketId] = key.split("|");
      return {
        lineType: lineType === "null" ? null : lineType,
        workTicketId: workTicketId === "" ? null : workTicketId,
      };
    });
    shipGroupData.forEach((shipdata) => {
      const { bundleId, shipGroups } = shipdata;
      shipGroups.forEach((shipGroup) => {
        const { addressId, contactId } = shipGroup;

        combinationsToProcess.forEach(({ lineType, workTicketId }) => {
          const requests = generateVinMaterialsRequest(vehiclesData, shipdata, addressId, contactId, bundleId, lineType, workTicketId);

          requests.forEach((request) => {
            if (request.materials && request.materials.length > 0) {
              // Reset materialLineId for each request entry - start from 000010
              let itemNo = 0;
              request.materials.forEach((material) => {
                itemNo += 10;
                material.materialLineId = String(itemNo).padStart(6, "0");
              });

              vinMaterialsRequest.push({
                addressId: request.addressId,
                contactId: request.contactId,
                lineType: lineType,
                workTicketId: workTicketId,
                vins: request.vins,
                materials: request.materials,
              });
            }
          });
        });
      });
    });
    const combinedRequest = combineVinMaterialsRequest(vinMaterialsRequest);
    combinedRequest.forEach((request) => {
      if (request.materials && request.materials.length > 0) {
        request.materials.forEach((material, index) => {
          material.materialLineId = String((index + 1) * 10).padStart(6, "0");
        });
      }
    });
    return combinedRequest;
  };

  const generateVinMaterialsRequest = (
    vehiclesData,
    shipGroupsData,
    addressId = null,
    contactId = null,
    bundleId = null,
    lineType = null,
    workTicketId = null
  ) => {
    const vinMaterialsRequest = [];

    const filteredShipGroups = shipGroupsData.shipGroups.filter(
      (shipGroup) => shipGroup.addressId === addressId && shipGroup.contactId === contactId
    );

    filteredShipGroups.forEach((shipGroup) => {
      const vins = [];

      vehiclesData.forEach((vehicleGroup) => {
        Object.values(vehicleGroup).forEach((vehicleData) => {
          vehicleData.data.forEach((dataItem) => {
            Object.values(dataItem.vehicles).forEach((vehicleArray) => {
              vehicleArray.forEach((vehicle) => {
                if (vehicleData.addressId === addressId && vehicleData.contactId === contactId && vehicleData.bundleId === bundleId) {
                  // Exclude warning vehicles
                  const isWarning = vehicle.vehicleStatus.toLowerCase().includes("warning");
                  if (isWarning) {
                    return;
                  }

                  const enabledMaterials = vehicle.materialMapping.filter((material) => {
                    const isEnabled = material.enabled !== false;
                    const materialLineType = material.lineType;
                    const materialWorkTicketId = material.workTicketId || null;
                    const shouldInclude =
                      lineType === null
                        ? materialLineType === "Fulfill" || !materialLineType || materialLineType === ""
                        : materialLineType === lineType;
                    const workTicketMatches =
                      workTicketId === null ? materialWorkTicketId === null || !materialWorkTicketId : materialWorkTicketId === workTicketId;
                    return isEnabled && shouldInclude && workTicketMatches;
                  });
                  if (enabledMaterials.length === 0) {
                    return;
                  }

                  vins.push({
                    id: vehicle.id,
                    vinStatus: vehicle.vehicleStatus,
                    type: vehicle.deviceType,
                    vinMaterials: enabledMaterials.map((material) => material.id).join(", "),
                    allMaterials: enabledMaterials,
                  });
                }
              });
            });
          });
        });
      });

      const materials = [];
      let itemNo = 0;
      vins.forEach((vin) => {
        const uniqueHardwareIds = new Set();

        vin.allMaterials.forEach((material) => {
          if (material.enabled !== false) {
            uniqueHardwareIds.add(material.hardwareId);
          }
        });

        // Process each unique hardwareId for the current vehicle
        uniqueHardwareIds.forEach((hardwareId) => {
          const materialsWithSameHardwareId = vin.allMaterials.filter((m) => m.hardwareId === hardwareId);
          let material;
          if (materialsWithSameHardwareId.length > 1) {
            material = materialsWithSameHardwareId.find((m) => m.type === "Core");
            if (!material) {
              return;
            }
          } else {
            material = materialsWithSameHardwareId[0];
          }

          const normalizedProcessingCode = material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode;
          const materialAggregationKey = getMaterialAggregationKey(material.hardwareId, material.techRefId, bundleId, normalizedProcessingCode);

          const existingMaterial = materials.find(
            (m) => getMaterialAggregationKey(m.materialId, m.techRefId, m.baseItemId, m.processingCode) === materialAggregationKey
          );
          itemNo += 10;
          if (vin.type === "KEYFOB" && typeof material.quantity === "number") {
            if (existingMaterial) {
              existingMaterial.summaryQty += material.quantity;
            } else {
              const newMaterial = {
                id: material.hardwareIdKey,
                materialId: material.hardwareId,
                materialName: material.hardwareName,
                summaryQty: material.quantity,
                materialLineId: String(itemNo)?.padStart(6, "0"),
                unitMeasure: "EA",
                techRefId: material.techRefId,
                processingCode: normalizedProcessingCode,
                installedQuantity: "",
                chargePrice: getChargePrice(
                  material.techRefId,
                  0,
                  material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode
                ),
                family: "",
                customerCharge: "",
                serviceProcessType: "",
                invoiceRelevant: "",
                customerPONumber: cspSessionData?.CSP_CUstomer_PO_Number,
                customerPONumberKut: cspSessionData?.CSP_CUstomer_PO_Number,
                baseItemId: bundleId,
                esnToBeReturned: material?.esnToBeReturned ? material.esnToBeReturned : "",
                sapId: material.subscriptionId,
                contractId: material.subscriptionIdKey,
                contactName: material.subscriptionName,
                orderType: material.orderType,
                contractOverride: material.upsell == true ? "Yes" : material.upsell == false ? "No" : null,
              };
              materials.push(newMaterial);
            }
          } else {
            if (existingMaterial) {
              existingMaterial.summaryQty += 1;
            } else {
              materials.push({
                id: material.hardwareIdKey,
                materialId: material.hardwareId,
                materialName: material.hardwareName,
                summaryQty: 1,
                materialLineId: String(itemNo)?.padStart(6, "0"),
                unitMeasure: "EA",
                techRefId: material.techRefId,
                processingCode: normalizedProcessingCode,
                installedQuantity: "",
                chargePrice: getChargePrice(
                  material.techRefId,
                  material?.chargeAmt,
                  material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode
                ),
                family: "",
                customerCharge: "",
                serviceProcessType: "",
                invoiceRelevant: "",
                customerPONumber: cspSessionData?.CSP_CUstomer_PO_Number,
                customerPONumberKut: cspSessionData?.CSP_CUstomer_PO_Number,
                baseItemId: bundleId,
                esnToBeReturned: material?.esnToBeReturned ? material.esnToBeReturned : "",
                sapId: material.subscriptionId,
                contractId: material.subscriptionIdKey,
                contactName: material.subscriptionName,
                orderType: material.orderType,
                contractOverride: material.upsell == true ? "Yes" : material.upsell == false ? "No" : null,
              });
            }
          }
        });
      });

      removeAllMaterials(vins); // Remove allMaterials from vins before pushing to vinMaterialsRequest
      if (materials.length > 0) {
        vinMaterialsRequest.push({
          addressId,
          contactId,
          vins,
          materials,
        });
      }
    });

    return vinMaterialsRequest;
  };
  // Generate the vinMaterialsRequest
  const commonCreateWorkTicketAPIRequest = (requestDateValue = null) => {
    try {
      let data = {};
      let requestDateToUse = requestDateValue || moment(new Date()).add(7, "days").format("YYYYMMDD");
      data = {
        createdBy: `${cspSessionData?.firstName} ${cspSessionData?.lastName}`,
        createdByEmail: cspSessionData?.email,
        createdByEid: cspSessionData?.Employee_ID,
        assignTo: cspSessionData?.Employee_ID,
        assignedTo: `${cspSessionData?.firstName} ${cspSessionData?.lastName}`,
        assignedToEmail: cspSessionData?.email,
        assignedToEid: cspSessionData?.CSP[0].CSPOwnerEId || "",
        sourceWorkticket: null,
        requestDate: requestDateToUse,
        crmReferenceId: cspSessionData?.CSP?.[0]?.CRM_Ref_ID || "",
        currencyCode: cspSessionData?.currencyCode || "USD",
        documentType: cspSessionData?.CSP[0].CSPID !== "" ? "ZINS" : "ZSRQ",
        documentDate: moment(new Date()).format("YYYYMMDD"),
        salesOrg: salesOrgId ? salesOrgId : "",
        distributionChannel: cspSessionData?.distributionChannel || "02",
        division: cspSessionData?.division || "02",
        contractAccount: cspSessionData?.CONTRACT_ACCOUNT_ID?.[0] || "",
        erpVendorId: "",
        erpBusinessPartnerId: cspSessionData?.ERP_Partner_Number || "",
        erpTicketType: cspSessionData?.CSP[0].CSPID !== "" ? "ZINS" : "ZSRQ",
        erpProductRecipientPartyId: cspSessionData?.ResellerBusinessPartnerNumber || cspSessionData?.ERP_Partner_Number || "",
        salesRepId: cspSessionData?.Employee_ID,
        subStatus: "",
        oldDeliveryNo: "",
        providerOrder: providerOrder || "",
        notesForWarehouse: "Work Ticket Request",
        customerName: cspSessionData?.AccountName,
        customerNumber: cspSessionData?.AccountNo,
        cspId: cspSessionData?.CSP[0].CSPID || "",
        caseId:
          cspSessionData?.source?.toLowerCase() !== "csp" && cspSessionData.CASEDetails.length
            ? cspSessionData.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseSFDCID
            : "",
        caseNumber:
          cspSessionData?.source?.toLowerCase() !== "csp" && cspSessionData.CASEDetails.length
            ? cspSessionData?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0]?.CaseNumber
            : "",
        accountId: cspSessionData?.AccountID,
        resellerBusinessPartnerNumber: cspSessionData?.ResellerBusinessPartnerNumber || cspSessionData?.ERP_Partner_Number || "", // ResellerBusinessPartnerNumber
        erpPrimaryContactNumber: cspSessionData?.ERP_Primary_Contact_NUmber ?? "",
        accountName: cspSessionData?.AccountName,
        workTicketType: "Outbound",
      };
      return data;
    } catch (err) {
      notify("Error occurred while fetching Vehicle List. Please try again", "error", false);
    } finally {
      setIsLoading(false);
    }
  };

  const navigateToManualSchedule = (jobData) => {
    switchTab(7, { data: "WT" });
    addPage(AlternateManualEntryMetadata.id, {
      jobData: {
        ...jobData,
        contractAccount: cspSessionData?.CONTRACT_ACCOUNT_ID?.[0] || "",
        isReschedule: false,
        fromAutoSchedule: true,
        salesOrg: salesOrgId ? salesOrgId : "",
      },
      mapUrl: "",
    });
  };

  const AddJobRequest = (requestDateValue = null, createdGroup = null, addressId = null, contactId = null, wtNo = null) => {
    const vinsData = createdGroup.vehicles.map((vehicle) => ({
      id: vehicle.id,
      vinStatus: vehicle.vehicleStatus,
      type: vehicle.materialMapping[0]?.subscriptionName.includes("Non-") ? "Non Powered Asset" : vehicle.deviceType,
      vinMaterials: vehicle.materialMapping
        ? vehicle.materialMapping
            .filter((m) => m.enabled !== false)
            .map((m) => m.id)
            .join(", ")
        : "",
    }));
    const vinsFilteredData = vinsData.filter((v) => v.type === "VEHICLE" || v.type === "ASSET");

    let data = {};
    let requestDateToUse = requestDateValue || moment(new Date()).add(7, "days").format("YYYYMMDD");
    data = {
      status: "OPEN",
      startDate: moment(requestDateToUse, "YYYYMMDD").format("MM/DD/YYYY"),
      contactId: contactId,
      accountId: cspSessionData?.AccountID,
      addressId: addressId,
      distributionChannel: cspSessionData?.distributionChannel || "02",
      division: cspSessionData?.division || "02",
      customerName: cspSessionData?.AccountName,
      customerNumber: cspSessionData?.AccountNo,
      vztSegment: cspSessionData?.VZCSegement,
      isDeleted: false,
      erpLastModifiedAt: new Date(),
      extendedJobId: null,
      scheduleType: "AUTO",
      scheduleStartTime: "",
      scheduleEndDate: "",
      scheduleEndTime: "",
      erpBusinessPartnerId: cspSessionData?.ERP_Partner_Number || "",
      providerOrder: providerOrder || "",
      erpTicketType: cspSessionData?.CSP[0].CSPID !== "" ? "ZINS" : "ZSRQ",
      assignToName: JSON.parse(sessionStorage.getItem("Name")),
      erpProductRecipientPartyId: cspSessionData?.ResellerBusinessPartnerNumber || cspSessionData?.ERP_Partner_Number || "",
      salesOrg: salesOrgId ? salesOrgId : "",
      resellerBusinessPartnerNumber: cspSessionData?.ResellerBusinessPartnerNumber || cspSessionData?.ERP_Partner_Number || "",
      brand: cspSessionData?.Account_Brand,
      createdAt: new Date(),
      createdBy: `${cspSessionData?.firstName} ${cspSessionData?.lastName}`,
      createdByEmail: cspSessionData?.email,
      createdByEid: cspSessionData?.Employee_ID,
      modifiedAt: new Date(),
      modifiedBy: `${cspSessionData?.firstName} ${cspSessionData?.lastName}`,
      modifiedByEmail: cspSessionData?.email,
      modifiedByEid: cspSessionData?.Employee_ID,
      assignedTo: `${cspSessionData?.firstName} ${cspSessionData?.lastName}`,
      assignedToEmail: cspSessionData?.email,
      assignedToEid: cspSessionData?.CSP[0].CSPOwnerEId || "",
      vins: vinsFilteredData,
      jobDetails: [
        {
          cspSfdcId: cspSessionData?.CSP[0].CSPID || "",
          primaryDevice: null,
          addOns: "updated",
          vehicleCount: vinsFilteredData.length,
          jobType: "INSTALL",
          opportunityId: null,
          cspOwner: cspSessionData?.CSP[0].CSPOwner || "",
          cspName: cspSessionData?.CSP[0].CSPName || "",
          caseSfdcId: "",
          caseOwner: "",
          caseNumber: "",
          modifiedAt: new Date(),
          modifiedBy: cspSessionData?.SFDCUsername,
          createdAt: new Date(),
          createdBy: cspSessionData?.SFDCUsername,
          isDeleted: false,
          workTickets: [
            {
              workTicket: wtNo,
            },
          ],
        },
      ],
      contractAccountId: cspSessionData?.CONTRACT_ACCOUNT_ID?.[0] || "",
      crmReferenceId: cspSessionData?.CSP?.[0]?.CRM_Ref_ID || "",
      jobDurationDetails: [],
    };

    return data;
  };

  const appointmentsRequest = (requestDateValue, jobData) => {
    let requestDateToUse = requestDateValue || moment(new Date()).add(7, "days").format("YYYYMMDD");
    let data = {
      Header: {
        requestControlId: "vzc_" + Date.now(),
      },
      Body: {
        header: {
          clientAppName: "VZC",
          clientAppUserName: "ECOM",
          internationalFlag: cspSessionData?.CSP[0].vpmInternational,
        },
        orderNum: jobData.id,
        vendorId: jobData?.vendorId || null,
        addressLine1: jobData.address1,
        addressLine2: jobData.address2,
        city: jobData.city,
        state: jobData.stateCode,
        zipCode: jobData.zipCode,
        serviceRequestType: "INSTALL",
        startingDate: moment(requestDateToUse).format("YYYYMMDD"),
        customerType: cspSessionData?.VZCSegement,
        firstName: cspSessionData?.firstName,
        lastName: cspSessionData?.lastName,
        accountName: cspSessionData?.AccountName,
        jobDuration: jobData.appointmentLength * 60,
        serviceJobId: jobData.serviceJobId,
        billingCountry: cspSessionData?.BillingCountry,
      },
    };

    const distanceCalculationType = cspSessionData?.CSP[0].distanceDescription === "Mileage - Roundtrip" ? "roundtrip" : "oneway";

    if (cspSessionData?.CSP[0].vpmInternational) {
      data.Body.isRoundTrip = distanceCalculationType == "roundtrip" ? "Y" : "N";
    }

    return data;
  };

  const getTimeSlots = async (transactionId, isMore = false, skipLoader = false, requestDateValue, jobId, addJobResponseData) => {
    if (isMore && !skipLoader) {
      handlePercentCalculation(true);
      setSpinner(true);
    }
    // let response = await getSlots(transactionId, isMore);
    let response = await getSlots(transactionId, false);
    if (response.status === 200 && response?.data?.data.length) {
      const allNoSlots = response.data.data.every((slot) => slot.availabilityMessage === "No slots available");
      if (allNoSlots) {
        noSlotsJobDataRef.current = addJobResponseData;
        setShowNoSlotsDialog(true);
      } else {
        switchTab(6, {
          data: "WT",
          timeSlots: response.data.data,
          AtpDate: requestDateValue,
          jobId,
          transactionId: transactionId,
        });
      }
    } else {
      isMore &&
        notify(
          <>
            <span>No availability at this time. Please follow the fall back process by clicking </span>{" "}
            <TextLink
              href={kbArticleLink}
              size="small"
              type="inline"
              tabIndex="0"
              role="link"
              ariaLabel="kbArticleLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </TextLink>
          </>,
          "error"
        );
    }
    clearSpinner();
  };

  const handlePercentCalculation = (isMore = false, isCombined = false) => {
    let seconds = 0;
    let totalSeconds = isCombined ? 26 : isMore ? 11 : 15;
    spinnerPercentage = setInterval(() => {
      seconds += 1;
      let percent = Math.round((seconds * 100) / totalSeconds);
      percent > 98 ? setSpinnerValue(99) : setSpinnerValue(percent);
    }, 1000);
  };

  const clearSpinner = () => {
    clearInterval(spinnerPercentage);
    setSpinnerValue(99);
    setTimeout(() => {
      setSpinner(false);
      setSpinnerValue(0);
    }, 800);
  };

  const getObjectByBundleId = (data, bundleId) => {
    // Use the find method to get the object with the matching bundleId
    return data.find((item) => item.bundleId === bundleId);
  };

  const closeLoaderIn3Seconds = () => {
    setTimeout(() => {
      setLoader(false);
    }, 3000);
  };

  const handleCreateWorkTicketforAll = async (bundleId, addressId, contactId) => {
    if (isApiCallInProgress.current || createWorkTicketProgress) {
      return;
    }
    try {
      isApiCallInProgress.current = true;
      setCreateWorkTicketProgress(true);
      setCreateWorkTicketValidVehiclesOrAssetsButtonStatus(false);
      notification.setNotification(null);
      setLoader(true);
      let response = await getCreateAllWTTransactionStatus(orderNumber, transactionId || "");
      if (response?.data?.statusCode === "200" && response?.data) {
        let orderStatusData = response?.data?.data;
        let hasInProgress = false;
        setTransactionId(orderStatusData?.TransactionId);
        if (!orderStatusData || !Array.isArray(orderStatusData) || orderStatusData === null) {
          setTransactionOrderStatus(false);
        } else {
          if (Array.isArray(orderStatusData)) {
            hasInProgress = orderStatusData.some((order) => order.OrderStatus === "IN_PROGRESS");
            setTransactionOrderStatus(hasInProgress);
          } else {
            setTransactionOrderStatus(false);
            hasInProgress = false;
          }
        }

        if (hasInProgress === true) {
          setCreateWorkTicketValidVehiclesOrAssetsButtonStatus(false);
          setCreateWorkTicketProgress(true);
          setUpdatedVehicles([]);
        } else {
          let reqPayload = commonCreateWorkTicketAPIRequest();
          const vinMaterialsRequest = generateVinMaterialsRequestAll(allVehicleList.data, vehiclesHeaderData);
          reqPayload.vinMaterialsRequest = vinMaterialsRequest.map((request) => {
            const { workTicketId, ...rest } = request;
            return {
              ...rest,
              sourceWorkticket: workTicketId,
            };
          });

          const validateWorkTicketData = (data, source) => {
            if (source === "CSP") {
              const { providerOrder } = data;
              if (!providerOrder || providerOrder === "" || providerOrder === null) {
                return {
                  isValid: false,
                  message: "1ERP provider number is missing. Unable to create a work ticket",
                };
              }
            }
            return { isValid: true };
          };

          const validation = validateWorkTicketData(reqPayload, cspSessionData?.source);
          if (!validation.isValid) {
            setLoader(false);
            return setTimeout(() => {
              notification.setNotification(<SLNotification key={generate()} title={validation.message} type="error" fullBleed={true} />);
            }, 10);
          }

          let responseCreateTicket = await CreateWorkTicketAuto(reqPayload);
          // Clear the timeout if the response is received before 3 seconds

          if (
            responseCreateTicket.status === 200 &&
            responseCreateTicket?.data?.message.toLowerCase() === "success" &&
            responseCreateTicket?.data?.data?.response.toLowerCase() === "success"
          ) {
            const timeoutId = setTimeout(async () => {
              let response = await getCreateAllWTTransactionStatus(orderNumber, responseCreateTicket?.data?.data?.transactionId || "");
              if (response?.data?.statusCode === "200" && response?.data) {
                let orderStatusData = response?.data?.data;
                let hasInProgress = false;
                let orderFailed = false;
                setTransactionId(responseCreateTicket?.data?.data?.transactionId);
                if (!orderStatusData || !Array.isArray(orderStatusData) || orderStatusData === null) {
                  setTransactionOrderStatus(false);
                } else {
                  if (Array.isArray(orderStatusData)) {
                    hasInProgress = orderStatusData.some((order) => order.OrderStatus === "IN_PROGRESS");
                    setTransactionOrderStatus(hasInProgress);
                    orderFailed = orderStatusData.some((order) => order.OrderStatus === "FAILED");
                  } else {
                    setTransactionOrderStatus(false);
                    hasInProgress = false;
                  }
                }

                if (hasInProgress === true) {
                  setCreateWorkTicketValidVehiclesOrAssetsButtonStatus(false);
                  setCreateWorkTicketProgress(true);
                  setUpdatedVehicles([]);
                } else {
                  setCreateWorkTicketValidVehiclesOrAssetsButtonStatus(true);
                  setCreateWorkTicketProgress(false);
                  if (orderFailed) {
                    notification.setNotification(
                      <SLNotification
                        key={generate()}
                        title="We are currently experiencing issues creating bulk WT, please try again"
                        type="error"
                        fullBleed={true}
                      />
                    );
                    setLoader(false);
                  } else {
                    await fetchHeaderList();
                    notification.setNotification(<SLNotification key={generate()} title="WorkTicket created successfully" type="success" />);
                  }
                }
              }
            }, 3000);
            closeLoaderIn3Seconds();
          } else if (
            responseCreateTicket?.response?.status === 500 &&
            responseCreateTicket?.response?.data?.message?.toLowerCase().includes("reloading the page")
          ) {
            notification.setNotification(
              <SLNotification
                key={generate()}
                title={responseCreateTicket?.response?.data?.message.split("Error occured while Creating workticket ")[1]}
                type="info"
                fullBleed={true}
              />
            );
            setLoader(false);
            setCreateWorkTicketProgress(false);
            setCreateWorkTicketValidVehiclesOrAssetsButtonStatus(true);
          } else {
            notification.setNotification(
              <SLNotification
                key={generate()}
                title="We are currently experiencing issues creating bulk WT, please try again"
                type="error"
                fullBleed={true}
              />
            );
            setLoader(false);
          }
        }
      }
    } catch (err) {
      setLoader(false);
      setCreateWorkTicketValidVehiclesOrAssetsButtonStatus(true);
      setCreateWorkTicketProgress(false);
      notification.setNotification(
        <SLNotification
          key={generate()}
          title="We are currently experiencing issues creating bulk WTickets, please try again"
          type="error"
          fullBleed={true}
        />
      );
    } finally {
      isApiCallInProgress.current = false;
      //setLoader(false);
    }
  };

  const combineDataByAddressAndContact = (data) => {
    const combinedData = {};

    data.flat().forEach((entry) => {
      const { addressId, contactId, vins, materials } = entry;

      const key = `${addressId}-${contactId}`;

      if (!combinedData[key]) {
        combinedData[key] = {
          addressId,
          contactId,
          vins: [],
          materials: [],
        };
      }

      // Combine vins
      combinedData[key].vins.push(...vins);

      // Combine materials and increment materialLineId
      let materialLineIdStart = combinedData[key].materials.length
        ? parseInt(combinedData[key].materials[combinedData[key].materials.length - 1].materialLineId, 10) + 10
        : 10;

      materials.forEach((material) => {
        const updatedMaterial = { ...material, materialLineId: String(materialLineIdStart).padStart(6, "0") };
        combinedData[key].materials.push(updatedMaterial);
        materialLineIdStart += 10;
      });
    });

    return Object.values(combinedData);
  };

  // Helper function to extract all materials from vehicles in a group
  const extractMaterialsFromVehicles = (vehicles, bundleIds, addressId, contactId, lineType, workTicketId = null) => {
    const materials = [];
    const bundleIdsArray = Array.isArray(bundleIds) ? bundleIds : [bundleIds];

    // Get actual vehicle data from cache
    bundleIdsArray.forEach((singleBundleId) => {
      const cacheKey = `${singleBundleId}_${addressId}_${contactId}`;
      const cachedData = allVehicleList?.data?.[0]?.[cacheKey];

      if (cachedData && cachedData.data.length > 0) {
        cachedData.data.forEach((dataItem) => {
          Object.entries(dataItem.vehicles).forEach(([vehicleBundleId, vehicleArray]) => {
            vehicleArray.forEach((vehicle) => {
              // Only process vehicles that are in this group
              const isInGroup = vehicles.some((v) => v.id === vehicle.id);
              if (!isInGroup) {
                return;
              }

              // Skip warning vehicles
              const isWarning = vehicle.vehicleStatus && vehicle.vehicleStatus.toLowerCase().includes("warning");
              if (isWarning) {
                return;
              }

              // Get all enabled materials for this vehicle that match the line type AND workTicketId
              const enabledMaterials = vehicle.materialMapping.filter((material) => {
                const isEnabled = material.enabled !== false;
                const materialLineType = material.lineType;
                const shouldIncludeLineType =
                  lineType === null ? materialLineType === "Fulfill" || !materialLineType || materialLineType === "" : materialLineType === lineType;
                const shouldIncludeWorkTicketId = (material.workTicketId ?? null) === (workTicketId ?? null);
                return isEnabled && shouldIncludeLineType && shouldIncludeWorkTicketId;
              });

              const uniqueHardwareIds = new Set();
              enabledMaterials.forEach((material) => {
                uniqueHardwareIds.add(material.hardwareId);
              });

              // Process each unique hardwareId
              uniqueHardwareIds.forEach((hardwareId) => {
                const materialsWithSameHardwareId = enabledMaterials.filter((m) => m.hardwareId === hardwareId);
                let selectedMaterial;
                if (materialsWithSameHardwareId.length > 1) {
                  selectedMaterial = materialsWithSameHardwareId.find((m) => m.type === "Core");
                  if (!selectedMaterial) {
                    return;
                  }
                } else {
                  selectedMaterial = materialsWithSameHardwareId[0];
                }
                const material = selectedMaterial;
                materials.push({
                  id: material.hardwareIdKey, // Use hardwareIdKey from materialMapping API
                  materialId: material.hardwareId,
                  materialName: material.hardwareName,
                  summaryQty: vehicle.deviceType === "KEYFOB" && typeof material.quantity === "number" ? material.quantity : 1,
                  techRefId: material.techRefId || "",
                  processingCode: material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode,
                  baseItemId: singleBundleId,
                  chargePrice: getChargePrice(
                    material.techRefId,
                    material.chargePrice,
                    material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode
                  ),
                  esnToBeReturned: material?.esnToBeReturned || "",
                  sapId: material.subscriptionId || "",
                  contractId: material.subscriptionIdKey || "",
                  contactName: material.subscriptionName || "",
                  orderType: material.orderType || "",
                  contractOverride: material.upsell == true ? "Yes" : material.upsell == false ? "No" : null,
                });
              });
            });
          });
        });
      }
    });

    // Club materials by hardwareIdKey (id) and sum up quantities
    const materialsMap = new Map();
    materials.forEach((material) => {
      const key = getMaterialAggregationKey(material.materialId, material.techRefId, material.baseItemId, material.processingCode);

      if (materialsMap.has(key)) {
        // Material already exists, add to summaryQty
        const existingMaterial = materialsMap.get(key);
        existingMaterial.summaryQty += material.summaryQty;
      } else {
        // New material, add to map
        materialsMap.set(key, { ...material });
      }
    });

    // Convert map back to array
    return Array.from(materialsMap.values());
  };

  const handleCreateButtonClick = async (
    bundleIds,
    addressId,
    contactId,
    lineType = null,
    reason = null,
    splitData = null,
    flag = null,
    workTicketId = null,
    selectedDeliveryDateParam = null
  ) => {
    if (isSingleApiCallInProgress.current || createWorkTicketProgress) {
      return;
    }
    const removeRowAfterSuccess = () => {
      setUpdatedVehicles((prev) =>
        prev.filter((row) => {
          const sameLineType = (row.lineType ?? null) === (lineType ?? null);
          const sameWorkTicketId = (row.workTicketId ?? null) === (workTicketId ?? null);
          const sameAddressContact =
            String(row.addressId) === String(addressId) && String(row.contactId) === String(contactId) && sameLineType && sameWorkTicketId;
          if (!sameAddressContact) return true;
          return false; // remove
        })
      );
    };
    try {
      isSingleApiCallInProgress.current = true;
      setCreateWorkTicketProgress(true);
      notification.setNotification(null);
      setLoader(true);

      // Find the vehicle groups for this specific request
      const bundleIdToMatch = Array.isArray(bundleIds) ? bundleIds[0] : bundleIds;
      const vehicleData = updatedVehicles.find(
        (vehicle) =>
          vehicle.addressId === addressId &&
          vehicle.contactId === contactId &&
          vehicle.bundleIds.includes(bundleIdToMatch) &&
          vehicle.lineType === lineType &&
          (vehicle.workTicketId ?? null) === (workTicketId ?? null)
      );
      if (!vehicleData) {
        setLoader(false);
        isSingleApiCallInProgress.current = false;
        setCreateWorkTicketProgress(false);
        notification.setNotification(
          <SLNotification key={generate()} title="Unable to find vehicle data. Please try again." type="error" fullBleed={true} />
        );
        return;
      }

      // If flag is provided, re-group vehicles with the flag parameter
      let vehicleGroups = vehicleData?.vehicleGroups;

      if (flag && vehicleData?.hardwareDetails) {
        // Re-group vehicles with the flag to force all to backorder

        vehicleGroups = groupVehiclesByATPStatus(bundleIds, addressId, contactId, vehicleData.hardwareDetails, lineType, flag, workTicketId);
      }

      // Check if this is a split zero inventory operation from the Grid component
      if (splitData && splitData.splitZeroInventory) {
        // Handle split operation with hardware groups directly from Grid
        const { hardwareWithATP, hardwareWithZeroATP } = splitData;

        // Get actual vehicles for both groups
        const { createdGroupVins, backorderGroupVins } = getVehiclesForSplitOperation(
          bundleIds,
          addressId,
          contactId,
          lineType,
          hardwareWithATP,
          hardwareWithZeroATP,
          workTicketId
        );

        // Create combined payload with both groups in single API call
        let reqPayload = commonCreateWorkTicketAPIRequest(selectedDeliveryDateParam);
        reqPayload.isAtpCheck = isAtpCheck;
        reqPayload.atpChangeReason = reason || null;
        reqPayload.sourceWorkticket = vehicleData?.workTicketId || null;

        const vinMaterialsRequest = [];

        // Add created group materials (hardware with ATP)
        if (hardwareWithATP && hardwareWithATP.length > 0) {
          // Extract ALL materials from vehicles in the created group using the helper function
          const createdMaterialsFromVehicles = extractMaterialsFromVehicles(
            createdGroupVins.map((v) => ({ id: v.id })), // Convert to vehicle object format
            bundleIds,
            addressId,
            contactId,
            lineType,
            workTicketId
          );

          const createdMaterials = createdMaterialsFromVehicles.map((material, index) => {
            const materialLineId = String((index + 1) * 10).padStart(6, "0");
            return {
              id: material.id, // Use hardwareIdKey from extractMaterialsFromVehicles
              materialId: material.materialId,
              materialName: material.materialName,
              summaryQty: material.summaryQty,
              materialLineId: materialLineId,
              unitMeasure: "EA",
              techRefId: material.techRefId || "",
              processingCode: material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode,
              installedQuantity: "",
              chargePrice: getChargePrice(
                material.techRefId,
                material.chargePrice,
                material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode
              ),
              family: "",
              customerCharge: "",
              serviceProcessType: "",
              invoiceRelevant: "",
              customerPONumber: cspSessionData?.CSP_CUstomer_PO_Number || "",
              customerPONumberKut: cspSessionData?.CSP_CUstomer_PO_Number || "",
              baseItemId: material.baseItemId || material.bundleId || (Array.isArray(bundleIds) ? bundleIds[0] : bundleIds),
              esnToBeReturned: material.esnToBeReturned || "",
              sapId: material.sapId || "",
              contractId: material.contractId || "",
              contactName: material.contactName || "",
              orderType: material.orderType || "",
              contractOverride: material.contractOverride || null,
              groupType: "Created",
            };
          });

          vinMaterialsRequest.push({
            addressId,
            contactId,
            vins: createdGroupVins, // Now populated with actual vehicle data
            materials: createdMaterials,
            groupType: "Created",
          });
        }

        // Add backorder group materials (hardware with zero ATP)
        if (hardwareWithZeroATP && hardwareWithZeroATP.length > 0) {
          // Extract ALL materials from vehicles in the backorder group using the helper function
          const backorderMaterialsFromVehicles = extractMaterialsFromVehicles(
            backorderGroupVins.map((v) => ({ id: v.id })), // Convert to vehicle object format
            bundleIds,
            addressId,
            contactId,
            lineType,
            workTicketId
          );

          // Start backorder materials from 000010 (not continuing from created group)
          const backorderMaterials = backorderMaterialsFromVehicles.map((material, index) => {
            const materialLineId = String((index + 1) * 10).padStart(6, "0"); // Starts from 000010
            return {
              id: material.id, // Use hardwareIdKey from extractMaterialsFromVehicles
              materialId: material.materialId,
              materialName: material.materialName,
              summaryQty: material.summaryQty,
              materialLineId: materialLineId,
              unitMeasure: "EA",
              techRefId: material.techRefId || "",
              processingCode: material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode,
              installedQuantity: "",
              chargePrice: getChargePrice(
                material.techRefId,
                material.chargePrice,
                material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode
              ),
              family: "",
              customerCharge: "",
              serviceProcessType: "",
              invoiceRelevant: "",
              customerPONumber: cspSessionData?.CSP_CUstomer_PO_Number || "",
              customerPONumberKut: cspSessionData?.CSP_CUstomer_PO_Number || "",
              baseItemId: material.baseItemId || material.bundleId || (Array.isArray(bundleIds) ? bundleIds[0] : bundleIds),
              esnToBeReturned: material.esnToBeReturned || "",
              sapId: material.sapId || "",
              contractId: material.contractId || "",
              contactName: material.contactName || "",
              orderType: material.orderType || "",
              contractOverride: material.contractOverride || null,
              groupType: "Backorder",
            };
          });

          vinMaterialsRequest.push({
            addressId,
            contactId,
            vins: backorderGroupVins, // Now populated with actual vehicle data
            materials: backorderMaterials,
            groupType: "Backorder",
          });
        }

        // Single API call for split operation
        // Filter out empty VIN groups
        const filteredVinMaterialsRequest = vinMaterialsRequest.filter((g) => Array.isArray(g.vins) && g.vins.length > 0);
        if (!filteredVinMaterialsRequest.length) {
          setLoader(false);
          notification.setNotification(
            <SLNotification key={generate()} title="No VINs available to create work ticket" type="error" fullBleed={true} />
          );
          return;
        }
        reqPayload.vinMaterialsRequest = filteredVinMaterialsRequest;

        // Validate and make single API call
        const validateWorkTicketData = (data, source) => {
          if (source === "CSP") {
            const { providerOrder } = data;
            if (!providerOrder || providerOrder === "" || providerOrder === null) {
              return {
                isValid: false,
                message: "1ERP provider number is missing. Unable to create a work ticket",
              };
            }
          }
          return { isValid: true };
        };

        const validation = validateWorkTicketData(reqPayload, cspSessionData?.source);
        if (!validation.isValid) {
          setLoader(false);
          return setTimeout(() => {
            notification.setNotification(<SLNotification key={generate()} title={validation.message} type="error" fullBleed={true} />);
          }, 10);
        }

        // Single API call for split operation
        let response = await CreateWorkTicketAuto(reqPayload);

        if (
          response.status === 200 &&
          response?.data?.message.toLowerCase() === "success" &&
          response?.data?.data?.response?.toLowerCase() === "success"
        ) {
          // Set removal criteria BEFORE refreshing list so it is excluded once data reloads
          removalCriteriaRef.current = { addressId, contactId, lineType: lineType ?? null, workTicketId: vehicleData?.workTicketId ?? null };
          // Optimistic remove so user sees row disappear immediately
          removeRowAfterSuccess();
          // Delay refresh so UI shows removal instantly; prevents brief re-add flicker
          setTimeout(fetchHeaderList, 800);
          notify("WorkTickets created successfully for both Created and Backorder groups via split operation", "success", false);
        } else if (response?.response?.status === 500 && response?.response?.data?.message?.toLowerCase().includes("reloading the page")) {
          notification.setNotification(
            <SLNotification
              key={generate()}
              title={response?.response?.data?.message.split("Error occured while Creating workticket ")[1]}
              type="info"
              fullBleed={true}
            />
          );
          setLoader(false);
        } else {
          notification.setNotification(
            <SLNotification
              key={generate()}
              title="We are currently experiencing issues creating WT, please try again"
              type="error"
              fullBleed={true}
            />
          );
          setLoader(false);
        }

        // Exit early after handling split operation
        return;
      }

      // ...existing code for regular operations...
      // Check if we have vehicle groups from ATP check
      if (vehicleGroups) {
        const { createdGroup, backorderGroup } = vehicleGroups;

        // Require at least one VIN in group (vehicles array length > 0)
        const hasCreatedContent = createdGroup.vehicles.length > 0; // && createdGroup.materials.length > 0 (materials assumed if VINs exist)
        const hasBackorderContent = backorderGroup.vehicles.length > 0; // && backorderGroup.materials.length > 0

        if (hasCreatedContent || hasBackorderContent) {
          // When only one group has content, still use single API call with the available group
          let requestDateValue = null;
          if (selectedDeliveryDateParam) {
            const deliveryDateMoment = moment(selectedDeliveryDateParam, ["MMMM D, yyyy", "MMM D, yyyy", "YYYY-MM-DD"], true);
            if (deliveryDateMoment.isValid()) {
              requestDateValue = deliveryDateMoment.format("YYYYMMDD");
            }
          }
          let reqPayload = commonCreateWorkTicketAPIRequest(requestDateValue);
          reqPayload.isAtpCheck = isAtpCheck;
          reqPayload.atpChangeReason = reason || null;
          reqPayload.sourceWorkticket = vehicleData?.workTicketId || null;

          // Create combined vinMaterialsRequest with available groups
          const vinMaterialsRequest = [];

          // Add created group if it has content
          if (hasCreatedContent) {
            // Extract ALL materials from vehicles in the created group
            const createdMaterialsFromVehicles = extractMaterialsFromVehicles(
              createdGroup.vehicles,
              bundleIds,
              addressId,
              contactId,
              lineType,
              workTicketId
            );

            const createdMaterials = createdMaterialsFromVehicles.map((material, index) => {
              const materialLineId = String((index + 1) * 10).padStart(6, "0");
              return {
                id: material.id,
                materialId: material.materialId,
                materialName: material.materialName,
                summaryQty: material.summaryQty,
                materialLineId: materialLineId,
                unitMeasure: "EA",
                techRefId: material.techRefId || "",
                processingCode: material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode,
                installedQuantity: "",
                chargePrice: getChargePrice(
                  material.techRefId,
                  material.chargePrice,
                  material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode
                ),
                family: "",
                customerCharge: "",
                serviceProcessType: "",
                invoiceRelevant: "",
                customerPONumber: cspSessionData?.CSP_CUstomer_PO_Number || "",
                customerPONumberKut: cspSessionData?.CSP_CUstomer_PO_Number || "",
                baseItemId: material.baseItemId || material.bundleId || (Array.isArray(bundleIds) ? bundleIds[0] : bundleIds),
                esnToBeReturned: material.esnToBeReturned || "",
                sapId: material.sapId || "",
                contractId: material.contractId || "",
                contactName: material.contactName || "",
                orderType: material.orderType || "",
                contractOverride: material.contractOverride || null,
                groupType: "Created",
              };
            });

            vinMaterialsRequest.push({
              addressId,
              contactId,
              vins: createdGroup.vehicles.map((vehicle) => ({
                id: vehicle.id,
                vinStatus: vehicle.vehicleStatus,
                type: vehicle.deviceType,
                vinMaterials: vehicle.materialMapping
                  ? vehicle.materialMapping
                      .filter((m) => m.enabled !== false)
                      .map((m) => m.id)
                      .join(", ")
                  : "",
                groupType: "Created",
              })),
              materials: createdMaterials,
              groupType: "Created",
            });
          }

          // Add backorder group if it has content
          if (hasBackorderContent) {
            // Extract ALL materials from vehicles in the backorder group
            const backorderMaterialsFromVehicles = extractMaterialsFromVehicles(
              backorderGroup.vehicles,
              bundleIds,
              addressId,
              contactId,
              lineType,
              workTicketId
            );

            const materialOffset = hasCreatedContent ? vinMaterialsRequest[0].materials.length : 0;
            const backorderMaterials = backorderMaterialsFromVehicles.map((material, index) => {
              const materialLineId = String((materialOffset + index + 1) * 10).padStart(6, "0");
              return {
                id: material.id, // Use the unique material ID from extractMaterialsFromVehicles
                materialId: material.materialId,
                materialName: material.materialName,
                summaryQty: material.summaryQty,
                materialLineId: materialLineId,
                unitMeasure: "EA",
                techRefId: material.techRefId || "",
                processingCode: material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode,
                installedQuantity: "",
                chargePrice: getChargePrice(
                  material.techRefId,
                  material.chargePrice,
                  material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode
                ),
                family: "",
                customerCharge: "",
                serviceProcessType: "",
                invoiceRelevant: "",
                customerPONumber: cspSessionData?.CSP_CUstomer_PO_Number || "",
                customerPONumberKut: cspSessionData?.CSP_CUstomer_PO_Number || "",
                baseItemId: material.baseItemId || material.bundleId || (Array.isArray(bundleIds) ? bundleIds[0] : bundleIds),
                esnToBeReturned: material.esnToBeReturned || "",
                sapId: material.sapId || "",
                contractId: material.contractId || "",
                contactName: material.contactName || "",
                orderType: material.orderType || "",
                contractOverride: material.contractOverride || null,
                groupType: "Backorder",
              };
            });

            vinMaterialsRequest.push({
              addressId,
              contactId,
              vins: backorderGroup.vehicles.map((vehicle) => ({
                id: vehicle.id,
                vinStatus: vehicle.vehicleStatus,
                type: vehicle.deviceType,
                vinMaterials: vehicle.materialMapping
                  ? vehicle.materialMapping
                      .filter((m) => m.enabled !== false)
                      .map((m) => m.id)
                      .join(", ")
                  : "",
                groupType: "Backorder",
              })),
              materials: backorderMaterials,
              groupType: "Backorder",
            });
          }

          // Filter out any group without VINs before validation / API
          reqPayload.vinMaterialsRequest = vinMaterialsRequest.filter((g) => Array.isArray(g.vins) && g.vins.length > 0);
          if (!reqPayload.vinMaterialsRequest.length) {
            setLoader(false);
            notification.setNotification(
              <SLNotification key={generate()} title="No VINs available to create work ticket" type="error" fullBleed={true} />
            );
            return;
          }

          // Validate required fields
          const validateWorkTicketData = (data, source) => {
            if (source === "CSP") {
              const { providerOrder } = data;
              if (!providerOrder || providerOrder === "" || providerOrder === null) {
                return {
                  isValid: false,
                  message: "1ERP provider number is missing. Unable to create a work ticket",
                };
              }
            }
            return { isValid: true };
          };

          const validation = validateWorkTicketData(reqPayload, cspSessionData?.source);
          if (!validation.isValid) {
            setLoader(false);
            return setTimeout(() => {
              notification.setNotification(<SLNotification key={generate()} title={validation.message} type="error" fullBleed={true} />);
            }, 10);
          }

          // Use single CreateWorkTicketAuto call for both scenarios
          let response = await CreateWorkTicketSingle(reqPayload);
          if (
            response.status === 200 &&
            response?.data?.message.toLowerCase() === "success" &&
            response?.data?.data?.response?.toLowerCase() === "success"
          ) {
            // let successMessage = "WorkTicket created successfully";
            // if (hasCreatedContent && hasBackorderContent) {
            //   successMessage = "WorkTickets created successfully for both Created and Backorder groups";
            // } else if (hasCreatedContent) {
            //   successMessage = "WorkTicket created successfully for Created group";
            // } else if (hasBackorderContent) {
            //   successMessage = "WorkTicket created successfully for Backorder group";
            // }

            // notification.setNotification(<SLNotification key={generate()} title={successMessage} type="success" />);
            // Ensure removal after refresh
            removalCriteriaRef.current = { addressId, contactId, lineType: lineType ?? null, workTicketId: vehicleData?.workTicketId ?? null };
            // Optimistic remove
            removeRowAfterSuccess();
            setTimeout(fetchHeaderList, 800);

            let wtNo = response?.data?.data?.workticketId;
            setCreateWorkTicketProgress(false);
            // Add job process
            const addJobPayload = AddJobRequest(requestDateValue, createdGroup, addressId, contactId, wtNo);
            if (hasBackorderContent) {
              // Show work tickets success modal
              const workTicketNumbers = wtNo.split(","); // Replace with actual extraction logic if needed
              setWtSuccessNumbers(workTicketNumbers);
              setShowWTModal(true);
            } else {
              if (addJobPayload.vins.length === 0) {
                // Show work tickets success modal
                const workTicketNumbers = wtNo.split(","); // Replace with actual extraction logic if needed
                setWtSuccessNumbers(workTicketNumbers);
                setShowWTModal(true);
              } else {
                setLoader(true);
                let addJobResponse = await addJobNew(addJobPayload);
                if (addJobResponse.status === 200 && addJobResponse?.data?.data?.id) {
                  setLoader(false);
                  // notify("Job created successfully", "success");
                  let jobId = addJobResponse.data.data.id;
                  // Single continuous loader for both getSchedule and getTimeSlots
                  handlePercentCalculation(false, true);
                  setSpinner(true);

                  const appointmentsPayload = appointmentsRequest(requestDateValue, addJobResponse.data.data);
                  let scheduleResponse = await getSchedule(jobId, appointmentsPayload);
                  if (scheduleResponse.status === 200 && scheduleResponse?.data?.data.transactionId !== "") {
                    // Pass skipLoader=true so getTimeSlots does not restart the loader
                    await getTimeSlots(scheduleResponse.data.data.transactionId, true, true, requestDateValue, jobId, addJobResponse.data.data);
                  } else {
                    clearSpinner();
                    notify(
                      <>
                        <span>No availability at this time. Please follow the fall back process by clicking </span>{" "}
                        <TextLink
                          href={kbArticleLink}
                          size="small"
                          type="inline"
                          tabIndex="0"
                          role="link"
                          ariaLabel="kbArticleLink"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          here
                        </TextLink>
                      </>,
                      "error"
                    );
                  }
                } else if (addJobResponse.status === 206 && addJobResponse?.data?.statusCode === "206") {
                  setLoader(false);
                  // Show work tickets success modal
                  const workTicketNumbers = wtNo.split(","); // Replace with actual extraction logic if needed
                  setWtSuccessNumbers(workTicketNumbers);
                  setShowWTModal(true);
                } else {
                  setLoader(false);
                  // notify("Job creation failed due to an unexpected error", "error");
                  switchTab(3);
                }
              }
            }
          } else if (response?.response?.status === 500 && response?.response?.data?.message?.toLowerCase().includes("reloading the page")) {
            notification.setNotification(
              <SLNotification
                key={generate()}
                title={response?.response?.data?.message.split("Error occured while Creating workticket ")[1]}
                type="info"
                fullBleed={true}
              />
            );
            setLoader(false);
          } else {
            notification.setNotification(
              <SLNotification
                key={generate()}
                title="We are currently experiencing issues creating WT, please try again"
                type="error"
                fullBleed={true}
              />
            );
            setLoader(false);
          }
        }
      } else {
        // Fallback to original logic if no vehicle groups available
        // Use CreateWorkTicketAuto instead of CreateWorkTicketSingle for consistency
        const vinMaterialsRequests = bundleIds.map((bundleId) => {
          const singleBundleData = getObjectByBundleId(vehiclesHeaderData, bundleId);
          const vinMaterialsRequest = generateVinMaterialsRequest(allVehicleList.data, singleBundleData, addressId, contactId, bundleId, lineType);
          return vinMaterialsRequest;
        });
        const completeSingleRequest = combineDataByAddressAndContact(vinMaterialsRequests);

        // Filter out groups with zero VINs
        const filteredSingleRequest = completeSingleRequest.filter((g) => Array.isArray(g.vins) && g.vins.length > 0);
        if (!filteredSingleRequest.length) {
          setLoader(false);
          notification.setNotification(
            <SLNotification key={generate()} title="No VINs available to create work ticket" type="error" fullBleed={true} />
          );
          return;
        }

        // Combine all vinMaterialsRequests into a single payload
        let requestDateValue = null;
        if (selectedDeliveryDateParam) {
          const deliveryDateMoment = moment(selectedDeliveryDateParam, ["MMMM D, yyyy", "MMM D, yyyy", "YYYY-MM-DD"], true);
          if (deliveryDateMoment.isValid()) {
            requestDateValue = deliveryDateMoment.format("YYYYMMDD");
          }
        }
        let reqPayload = commonCreateWorkTicketAPIRequest(requestDateValue);
        reqPayload.isAtpCheck = isAtpCheck;
        reqPayload.vinMaterialsRequest = filteredSingleRequest;
        reqPayload.atpChangeReason = reason || null;
        reqPayload.sourceWorkticket = vehicleData?.workTicketId || null;

        // Validate required fields
        const validateWorkTicketData = (data, source) => {
          if (source === "CSP") {
            const { providerOrder } = data;
            if (!providerOrder || providerOrder === "" || providerOrder === null) {
              return {
                isValid: false,
                message: "1ERP provider number is missing. Unable to create a work ticket",
              };
            }
          }
          return { isValid: true };
        };

        const validation = validateWorkTicketData(reqPayload, cspSessionData?.source);
        if (!validation.isValid) {
          setLoader(false);
          return setTimeout(() => {
            notification.setNotification(<SLNotification key={generate()} title={validation.message} type="error" fullBleed={true} />);
          }, 10);
        }

        // Use CreateWorkTicketAuto for consistency with other calls
        let response = await CreateWorkTicketAuto(reqPayload);
        if (
          response.status === 200 &&
          response?.data?.message.toLowerCase() === "success" &&
          response?.data?.data?.response?.toLowerCase() === "success"
        ) {
          removalCriteriaRef.current = { addressId, contactId, lineType: lineType ?? null, workTicketId: vehicleData?.workTicketId ?? null };
          // Optimistic remove
          removeRowAfterSuccess();
          setTimeout(fetchHeaderList, 800);
          notification.setNotification(<SLNotification key={generate()} title="WorkTicket created successfully" type="success" />);
        } else if (response?.response?.status === 500 && response?.response?.data?.message?.toLowerCase().includes("reloading the page")) {
          notification.setNotification(
            <SLNotification
              key={generate()}
              title={response?.response?.data?.message.split("Error occured while Creating workticket ")[1]}
              type="info"
              fullBleed={true}
            />
          );
          setLoader(false);
        } else {
          notification.setNotification(
            <SLNotification
              key={generate()}
              title="We are currently experiencing issues creating WT, please try again"
              type="error"
              fullBleed={true}
            />
          );
          setLoader(false);
        }
      }
    } catch (err) {
      notification.setNotification(
        <SLNotification
          key={generate()}
          title="We are currently experiencing issues creating WTicket, please try again"
          type="error"
          fullBleed={true}
        />
      );
    } finally {
      isSingleApiCallInProgress.current = false;
      setLoader(false);
      setCreateWorkTicketProgress(false);
    }
  };

  // New function to group vehicles by ATP availability status
  const groupVehiclesByATPStatus = (bundleId, addressId, contactId, atpResponseData, lineType, flag = null, workTicketId = null) => {
    try {
      const bundleIds = Array.isArray(bundleId) ? bundleId : [bundleId];

      // Create maps for materials with ATP and without ATP
      const materialsWithATP = new Map();
      const materialsWithZeroATP = new Map();

      // Process ATP response to categorize materials
      atpResponseData.forEach((item) => {
        const materialId = item.materialId;
        const quantityATP = parseInt(item.quantityATP) || 0;

        if (quantityATP > 0) {
          materialsWithATP.set(materialId, item);
        } else {
          materialsWithZeroATP.set(materialId, item);
        }
      });

      const createdGroup = {
        vehicles: [],
        materials: [],
        status: "Created",
      };

      const backorderGroup = {
        vehicles: [],
        materials: [],
        status: "Backorder",
      };

      // Track material quantities for each group
      const createdMaterialsMap = new Map();
      const backorderMaterialsMap = new Map();

      // If flag is true, all vehicles go to backorder, skip processing
      if (flag) {
        // Process each bundle and add all vehicles to backorder
        bundleIds.forEach((singleBundleId) => {
          const cacheKey = `${singleBundleId}_${addressId}_${contactId}`;
          const cachedData = allVehicleList?.data?.[0]?.[cacheKey];

          if (cachedData && cachedData.data.length > 0) {
            cachedData.data.forEach((dataItem) => {
              Object.entries(dataItem.vehicles).forEach(([vehicleBundleId, vehicleArray]) => {
                vehicleArray.forEach((vehicle) => {
                  // Skip warning vehicles
                  const isWarning = vehicle.vehicleStatus && vehicle.vehicleStatus.toLowerCase().includes("warning");
                  if (isWarning) {
                    return;
                  }

                  // Get all enabled materials for this vehicle that match the line type AND workTicketId
                  const enabledMaterials = vehicle.materialMapping.filter((material) => {
                    const isEnabled = material.enabled !== false;
                    const materialLineType = material.lineType;
                    const shouldIncludeLineType =
                      lineType === null
                        ? materialLineType === "Fulfill" || !materialLineType || materialLineType === ""
                        : materialLineType === lineType;
                    const shouldIncludeWorkTicketId = (material.workTicketId ?? null) === (workTicketId ?? null);
                    return isEnabled && shouldIncludeLineType && shouldIncludeWorkTicketId;
                  });

                  if (enabledMaterials.length === 0) {
                    return;
                  }

                  // All vehicles go to backorder when flag is true
                  const vehicleForBackorder = {
                    ...vehicle,
                    groupStatus: "Backorder",
                  };
                  backorderGroup.vehicles.push(vehicleForBackorder);

                  // Add all materials from this vehicle to backorder materials
                  const uniqueHardwareIds = new Set();
                  enabledMaterials.forEach((material) => {
                    uniqueHardwareIds.add(material.hardwareId);
                  });

                  uniqueHardwareIds.forEach((hardwareId) => {
                    const materialsWithSameHardwareId = enabledMaterials.filter((m) => m.hardwareId === hardwareId);
                    let selectedMaterial;
                    if (materialsWithSameHardwareId.length > 1) {
                      selectedMaterial = materialsWithSameHardwareId.find((m) => m.type === "Core");
                      if (!selectedMaterial) {
                        return;
                      }
                    } else {
                      selectedMaterial = materialsWithSameHardwareId[0];
                    }

                    const materialId = selectedMaterial.hardwareId;
                    const atpData = atpResponseData.find((item) => item.materialId === materialId);

                    if (!backorderMaterialsMap.has(materialId)) {
                      backorderMaterialsMap.set(materialId, {
                        ...atpData,
                        totalQty: 0,
                      });
                    }

                    const currentMaterial = backorderMaterialsMap.get(materialId);
                    if (vehicle.deviceType === "KEYFOB" && typeof selectedMaterial.quantity === "number") {
                      currentMaterial.totalQty += selectedMaterial.quantity;
                    } else {
                      currentMaterial.totalQty += 1;
                    }
                  });
                });
              });
            });
          }
        });

        // Convert backorder materials map to array
        backorderGroup.materials = Array.from(backorderMaterialsMap.values());

        return {
          createdGroup,
          backorderGroup,
        };
      }

      // Normal processing when flag is false or null
      // Initialize created materials map with all materials that have ATP > 0
      materialsWithATP.forEach((item, materialId) => {
        createdMaterialsMap.set(materialId, {
          ...item,
          totalQty: item.totalQty || 0,
        });
      });

      // Process each bundle
      bundleIds.forEach((singleBundleId) => {
        const cacheKey = `${singleBundleId}_${addressId}_${contactId}`;
        const cachedData = allVehicleList?.data?.[0]?.[cacheKey];

        if (cachedData && cachedData.data.length > 0) {
          cachedData.data.forEach((dataItem) => {
            Object.entries(dataItem.vehicles).forEach(([vehicleBundleId, vehicleArray]) => {
              vehicleArray.forEach((vehicle) => {
                // Skip warning vehicles
                const isWarning = vehicle.vehicleStatus && vehicle.vehicleStatus.toLowerCase().includes("warning");
                if (isWarning) {
                  return;
                }

                // Get all enabled materials for this vehicle that match the line type AND workTicketId
                const enabledMaterials = vehicle.materialMapping.filter((material) => {
                  const isEnabled = material.enabled !== false;
                  const materialLineType = material.lineType;
                  const shouldIncludeLineType =
                    lineType === null
                      ? materialLineType === "Fulfill" || !materialLineType || materialLineType === ""
                      : materialLineType === lineType;
                  const shouldIncludeWorkTicketId = (material.workTicketId ?? null) === (workTicketId ?? null);

                  return isEnabled && shouldIncludeLineType && shouldIncludeWorkTicketId;
                });

                if (enabledMaterials.length === 0) {
                  return;
                }

                // Check if ANY material in this vehicle has zero ATP
                let hasAnyZeroATP = false;

                for (const material of enabledMaterials) {
                  const materialId = material.hardwareId;
                  if (materialsWithZeroATP.has(materialId)) {
                    hasAnyZeroATP = true;
                    break;
                  }
                }

                // Get unique hardware IDs for this vehicle
                const uniqueHardwareIds = new Set();
                enabledMaterials.forEach((material) => {
                  uniqueHardwareIds.add(material.hardwareId);
                });

                // If any material has zero ATP, entire vehicle goes to backorder
                if (hasAnyZeroATP) {
                  const vehicleForBackorder = {
                    ...vehicle,
                    groupStatus: "Backorder",
                  };
                  backorderGroup.vehicles.push(vehicleForBackorder);

                  // Add this vehicle's materials to backorder and reduce from created
                  uniqueHardwareIds.forEach((hardwareId) => {
                    const materialsWithSameHardwareId = enabledMaterials.filter((m) => m.hardwareId === hardwareId);
                    let selectedMaterial;
                    if (materialsWithSameHardwareId.length > 1) {
                      selectedMaterial = materialsWithSameHardwareId.find((m) => m.type === "Core");
                      if (!selectedMaterial) {
                        return;
                      }
                    } else {
                      selectedMaterial = materialsWithSameHardwareId[0];
                    }

                    const materialId = selectedMaterial.hardwareId;
                    const atpData = atpResponseData.find((item) => item.materialId === materialId);

                    let quantityToAdd = 0;
                    if (vehicle.deviceType === "KEYFOB" && typeof selectedMaterial.quantity === "number") {
                      quantityToAdd = selectedMaterial.quantity;
                    } else {
                      quantityToAdd = 1;
                    }

                    // Add to backorder materials
                    if (!backorderMaterialsMap.has(materialId)) {
                      backorderMaterialsMap.set(materialId, {
                        ...atpData,
                        totalQty: 0,
                      });
                    }
                    const backorderMaterial = backorderMaterialsMap.get(materialId);
                    backorderMaterial.totalQty += quantityToAdd;

                    // Reduce from created materials if it exists there
                    if (createdMaterialsMap.has(materialId)) {
                      const createdMaterial = createdMaterialsMap.get(materialId);
                      createdMaterial.totalQty -= quantityToAdd;
                      // If quantity becomes 0 or negative, remove from created
                      if (createdMaterial.totalQty <= 0) {
                        createdMaterialsMap.delete(materialId);
                      }
                    }
                  });
                } else {
                  // Only if ALL materials have ATP > 0, vehicle goes to created group
                  const vehicleForCreated = {
                    ...vehicle,
                    groupStatus: "Created",
                  };
                  createdGroup.vehicles.push(vehicleForCreated);
                }
              });
            });
          });
        }
      });

      // Convert maps to arrays
      createdGroup.materials = Array.from(createdMaterialsMap.values());
      backorderGroup.materials = Array.from(backorderMaterialsMap.values());

      return {
        createdGroup,
        backorderGroup,
      };
    } catch (error) {
      return {
        createdGroup: { vehicles: [], materials: [], status: "Created" },
        backorderGroup: { vehicles: [], materials: [], status: "Backorder" },
      };
    }
  };

  const handleATPCheck = async (bundleId, addressId, contactId, MMIDList, VINList, lineType, selectedDeliveryDate, workTicketId = null) => {
    notification.setNotification(null);
    setLoader(true);
    updateNewrelicStats();
    // Use selected date from modal if provided, else default to today + 7 days
    const requestedDeliveryDateMoment = selectedDeliveryDate
      ? moment(selectedDeliveryDate, ["MMMM D, yyyy", "MMM D, yyyy", "YYYY-MM-DD"], true)
      : null;
    let effectiveRequestedDate;
    if (requestedDeliveryDateMoment && requestedDeliveryDateMoment.isValid()) {
      effectiveRequestedDate = requestedDeliveryDateMoment;
    } else {
      effectiveRequestedDate = moment().add(7, "days");
    }
    let actualMMmidListLength = MMIDList.length;
    let afterAtpCheckMMIDListLength = 0;
    let itemNo = 0;
    let itemsList = MMIDList.map((mmid) => {
      itemNo += 10;
      return {
        itemNo: itemNo,
        itemCode: mmid.itemCode,
        itemDescription: mmid.itemDescription,
        orderQuantity: mmid.orderQuantity,
        unitOfMeasurement: "EA",
        requestedDeliveryDate: effectiveRequestedDate.format("YYYYMMDD"),
        type: mmid.type,
      };
    });
    let data = {
      shipToParty: cspSessionData?.ERP_Partner_Number,
      salesOrganization: salesOrgId ? salesOrgId : "",
      distributionChannel: cspSessionData?.distributionChannel,
      division: cspSessionData?.division,
      items: itemsList.map((it) => {
        const rest = { ...it };
        delete rest.itemDescription;
        delete rest.techRefId;
        delete rest.type;
        return rest;
      }),
    };
    let response = await ATPCheck(data);
    if (response?.status === 200) {
      let responseData = response.data.data.items;
      afterAtpCheckMMIDListLength = responseData.length;
      if (actualMMmidListLength === afterAtpCheckMMIDListLength) {
        setIsAtpCheck(true);
      }
      responseData = responseData.sort(function (a, b) {
        return Number(a.itemNo) > Number(b.itemNo) ? 1 : Number(b.itemNo) > Number(a.itemNo) ? -1 : 0;
      });

      let index = 0;
      let materialData = itemsList.map((items) => {
        let data = {
          materialId: items.itemCode,
          itemDescription: items.itemDescription,
          totalQty: items.orderQuantity,
          techRefId: items.techRefId,
          type: items.type,
        };
        if (responseData.length) {
          if (Number(items.itemNo) === Number(responseData[index].itemNo)) {
            data = {
              ...data,
              quantityATP: responseData[index].confirmedQuantity ? parseInt(responseData[index].confirmedQuantity) : 0,
              dateATP: responseData[index].confirmedDate ? moment(responseData[index].confirmedDate).format("YYYY-MM-DD") : "",
              addressId: addressId,
              contactId: contactId,
              bundleId: bundleId,
            };
            if (index < responseData.length - 1) {
              index += 1;
            }
          } else {
            data = { ...data, quantityATP: 0, dateATP: "--", addressId: addressId, contactId: contactId, bundleId: bundleId };
          }
          return data;
        } else {
          notification.setNotification(
            <SLNotification key={generate()} type={"info"} title="ATP Quantity is 0. Please validate before creating work ticket." fullBleed={true} />
          );
          data = { ...data, quantityATP: 0, dateATP: null, addressId: addressId, contactId: contactId, bundleId: bundleId };
          return data;
        }
      });

      // Group vehicles by ATP status (Created vs Backorder)
      const vehicleGroups = groupVehiclesByATPStatus(bundleId, addressId, contactId, materialData, lineType, null, workTicketId);

      // Store groups for later use in work ticket creation
      const copiedUpdatedVehicles = updatedVehicles.map((vehicle) => ({ ...vehicle }));
      const bundleIdToMatch = Array.isArray(bundleId) ? bundleId[0] : bundleId;
      const normalizedLineType = lineType ?? null;
      const normalizedWorkTicketId = workTicketId ?? null;
      const selectedIndex = copiedUpdatedVehicles.findIndex((vehicle) => {
        const vehicleLineType = vehicle.lineType ?? null;
        const vehicleWorkTicketId = vehicle.workTicketId ?? null;
        const matches =
          vehicle.addressId === addressId &&
          vehicle.contactId === contactId &&
          vehicle.bundleIds.includes(bundleIdToMatch) &&
          vehicleLineType === normalizedLineType &&
          vehicleWorkTicketId === normalizedWorkTicketId;
        return matches;
      });

      if (selectedIndex !== -1) {
        copiedUpdatedVehicles.forEach((vehicle, idx) => {
          if (idx !== selectedIndex) {
            vehicle.viewButtonClicked = false;
            delete vehicle.hardwareDetails;
            delete vehicle.vehicleGroups;
          }
        });
        copiedUpdatedVehicles[selectedIndex]["hardwareDetails"] = materialData;
        copiedUpdatedVehicles[selectedIndex]["viewButtonClicked"] = true;
        copiedUpdatedVehicles[selectedIndex]["vehicleGroups"] = vehicleGroups; // Store groups for later use
      }
      setUpdatedVehicles([...copiedUpdatedVehicles]);
    } else {
      notification.setNotification(
        <SLNotification
          key={generate()}
          title={
            <>
              <span>We are currently experiencing issues, please </span>{" "}
              <TextLink size="small" type="inline" tabIndex="0" role="link" onClick={() => handleATPCheck(MMIDList, VINList)}>
                try again
              </TextLink>
            </>
          }
          type="error"
          fullBleed={true}
        />
      );
    }
    setLoader(false);
  };

  const generateBundleRowData = (input, selAddressId, selContactId, address, contactName, selBundleId, fullAddress = null) => {
    const results = [];
    Object.entries(input[0]).forEach(([, value]) => {
      const { bundleId, addressId, contactId, data } = value;
      if (data.length === 0) {
        return;
      }
      if (selAddressId === addressId && selContactId === contactId && selBundleId === bundleId) {
        const lineTypeGroups = {};

        data?.forEach((dataItem) => {
          Object.values(dataItem.vehicles).forEach((vehicleArray) => {
            vehicleArray.forEach((vehicle) => {
              const isWarning = vehicle.vehicleStatus.toLowerCase().includes("warning");

              const enabledMaterials = vehicle.materialMapping.filter((mapping) => mapping.enabled !== false);

              const materialsToCheck = enabledMaterials.length > 0 || !isWarning ? enabledMaterials : vehicle.materialMapping;

              materialsToCheck.forEach((mapping) => {
                const lineType = mapping.lineType === "Reship" ? "Reship" : "Fulfill";
                const workTicketId = mapping.workTicketId || null;
                const key = `${lineType}|${workTicketId || ""}`;

                if (!lineTypeGroups[key]) {
                  lineTypeGroups[key] = { lineType, workTicketId, vehicles: [] };
                }
                if (!lineTypeGroups[key].vehicles.includes(vehicle)) {
                  lineTypeGroups[key].vehicles.push(vehicle);
                }
              });
            });
          });
        });

        Object.entries(lineTypeGroups).forEach(([, group]) => {
          const { lineType, workTicketId, vehicles } = group;
          if (vehicles.length > 0) {
            let readyVehiclesCount = 0;
            let totalVehiclesCount = 0;
            let needAttentionVehicles = 0;
            let hasKeyfob = false;
            let keyfobCount = 0;

            vehicles.forEach((vehicle) => {
              const hasEnabledMaterials = vehicle.materialMapping.some((mapping) => mapping.enabled !== false);
              const isWarning = vehicle.vehicleStatus.toLowerCase().includes("warning");

              if (isWarning) {
                needAttentionVehicles += 1;
              }

              if (!hasEnabledMaterials && !isWarning) {
                return;
              }

              if (vehicle.deviceType === "KEYFOB") {
                hasKeyfob = true;
                if (Array.isArray(vehicle.materialMapping)) {
                  const uniqueKeyfobHardwareIds = new Set();
                  vehicle.materialMapping.forEach((mapping) => {
                    if (
                      mapping.enabled !== false &&
                      (mapping.lineType === lineType || (lineType === "Fulfill" && (!mapping.lineType || mapping.lineType === "")))
                    ) {
                      const hwId = mapping.hardwareId || mapping.hardwareIdKey;
                      if (hwId && !uniqueKeyfobHardwareIds.has(hwId)) {
                        uniqueKeyfobHardwareIds.add(hwId);
                        keyfobCount += 1; // count each unique hardware id only once
                      }
                    }
                  });
                }
              } else {
                totalVehiclesCount += 1;
              }

              if (vehicle.vehicleStatus.toLowerCase() === "ready") {
                readyVehiclesCount += 1;
              }
            });

            results.push({
              bundleIds: [bundleId],
              addressId,
              address: fullAddress,
              contactId,
              contactName: contactName,
              readyVehicles: readyVehiclesCount,
              totalVehicles: totalVehiclesCount ? totalVehiclesCount : keyfobCount,
              needAttentionVehicles: needAttentionVehicles,
              viewORCreate: readyVehiclesCount > 0,
              keyfobCount: keyfobCount,
              hasKeyfob: hasKeyfob,
              viewButtonClicked: false,
              lineType: lineType === "Fulfill" ? null : lineType,
              workTicketId: workTicketId,
            });
          }
        });
      }
    });
    return results;
  };

  const createAddressString = (address, address1, city, stateCode, zipCode, countryCode) => {
    const fields = [address, address1, city, stateCode, zipCode, countryCode];
    return fields.filter((field) => field && field.trim() !== "").join(", ");
  };

  const getUniqueAddressContractSummary = (bundleList, allVehicles) => {
    const result = [];

    bundleList.forEach((bundle) => {
      const { bundleId, shipGroups } = bundle;
      shipGroups.forEach((shipGroup) => {
        const { addressId, address, address1, contactId, contactName, city, stateCode, countryCode, zipCode } = shipGroup;
        const fullAddress = createAddressString(address, address1, city, stateCode, zipCode, countryCode);
        const rowDataArray = generateBundleRowData(allVehicles.data, addressId, contactId, address, contactName, bundleId, fullAddress);

        if (Array.isArray(rowDataArray) && rowDataArray.length > 0) {
          result.push(...rowDataArray);
        }
      });
    });
    const result2 = combineBundlesByAddressAndContact(result).map((r) => ({
      ...r,
      rowKey: `${r.addressId}-${r.contactId}-${r.lineType ?? "FULFILL"}-${r.workTicketId ?? ""}-${
        Array.isArray(r.bundleIds) ? r.bundleIds.slice().sort().join("|") : r.bundleIds
      }`,
    }));
    return result2;
  };

  const combineBundlesByAddressAndContact = (data) => {
    const groupedData = [];

    data.forEach((item) => {
      const existingEntry = groupedData.find(
        (entry) =>
          entry.addressId === item.addressId &&
          entry.contactId === item.contactId &&
          entry.lineType === item.lineType &&
          entry.workTicketId === item.workTicketId
      );

      if (existingEntry) {
        // Combine bundleIds and update vehicle counts
        existingEntry.bundleIds = [...new Set([...existingEntry.bundleIds, ...item.bundleIds])];
        existingEntry.readyVehicles += item.readyVehicles;
        existingEntry.totalVehicles += item.totalVehicles;
        existingEntry.needAttentionVehicles += item.needAttentionVehicles;
        existingEntry.keyfobCount += item.keyfobCount;
      } else {
        // Add new entry
        groupedData.push({ ...item });
      }
    });

    return groupedData;
  };

  const hasReadyVehicles = (dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) {
      return false;
    }
    return dataArray.some((item) => item.readyVehicles > 0);
  };

  const handleClickOutside = () => {
    notification.setNotification(null);
  };
  const clickRef = useOutsideClick(handleClickOutside);

  const notify = (content, type) => {
    notification.setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />);
    setTimeout(() => {
      notification.setNotification(null);
    }, 5000);
  };

  useEffect(() => {
    const rowsWithReadyVehicles = updatedVehicles.filter((item) => item.readyVehicles > 0);
    setCreateWorkTicketValidVehiclesOrAssetsButtonStatus(rowsWithReadyVehicles.length > 1);
  }, [updatedVehicles]);

  // Helper function to create work ticket payload for a specific group
  const createWorkTicketPayload = async (bundleIds, addressId, contactId, lineType, reason, vehicleGroup, groupType) => {
    // Get base payload structure
    let reqPayload = commonCreateWorkTicketAPIRequest();

    // Set work ticket type based on group
    reqPayload.workTicketType = groupType === "Backorder" ? "Backorder" : "Outbound";
    reqPayload.isAtpCheck = isAtpCheck;
    reqPayload.atpChangeReason = reason || null;

    // Create materials list from the group
    const materialList = vehicleGroup.materials.map((material, index) => {
      const materialLineId = String((index + 1) * 10).padStart(6, "0");
      return {
        id: material.id || `${material.materialId}_${index}`,
        materialId: material.materialId,
        materialName: material.itemDescription,
        summaryQty: material.totalQty || material.orderQuantity || 1,
        materialLineId: materialLineId,
        unitMeasure: "EA",
        techRefId: material.techRefId || "",
        processingCode: material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode,
        installedQuantity: "",
        chargePrice: getChargePrice(
          material.techRefId,
          material.chargePrice,
          material.lineType === "Reship" ? getExchangeCode(material.processingCode) : material.processingCode
        ),
        family: "",
        customerCharge: "",
        serviceProcessType: "",
        invoiceRelevant: "",
        customerPONumber: cspSessionData?.CSP_CUstomer_PO_Number || "",
        customerPONumberKut: cspSessionData?.CSP_CUstomer_PO_Number || "",
        baseItemId: material.baseItemId || material.bundleId || (Array.isArray(bundleIds) ? bundleIds[0] : bundleIds),
        esnToBeReturned: material?.esnToBeReturned || "",
        sapId: material.sapId || "",
        contractId: material.contractId || "",
        contactName: material.contactName || "",
        orderType: material.orderType || "",
        contractOverride: material.contractOverride || null,
      };
    });

    // Create VIN materials request structure
    const vinMaterialsRequest = [
      {
        addressId,
        contactId,
        vins: vehicleGroup.vehicles.map((vehicle) => ({
          id: vehicle.id,
          vinStatus: vehicle.vehicleStatus,
          type: vehicle.deviceType,
          vinMaterials: vehicle.materialMapping
            ? vehicle.materialMapping
                .filter((m) => m.enabled !== false)
                .map((m) => m.id)
                .join(", ")
            : "",
        })),
        materials: materialList,
      },
    ];

    reqPayload.vinMaterialsRequest = vinMaterialsRequest;

    // Add group type identifier for tracking
    reqPayload.groupType = groupType;

    return reqPayload;
  };

  // Helper function to get vehicles for split operation based on material groups
  const getVehiclesForSplitOperation = (bundleIds, addressId, contactId, lineType, hardwareWithATP, hardwareWithZeroATP, workTicketId = null) => {
    const bundleIdsArray = Array.isArray(bundleIds) ? bundleIds : [bundleIds];
    const createdGroupVins = [];
    const backorderGroupVins = [];

    // Create maps for quick material lookup
    const atpMaterialIds = new Set(hardwareWithATP.map((hw) => hw.materialId));
    const zeroAtpMaterialIds = new Set(hardwareWithZeroATP.map((hw) => hw.materialId));

    bundleIdsArray.forEach((singleBundleId) => {
      const cacheKey = `${singleBundleId}_${addressId}_${contactId}`;
      const cachedData = allVehicleList?.data?.[0]?.[cacheKey];

      if (cachedData && cachedData.data.length > 0) {
        cachedData.data.forEach((dataItem) => {
          Object.entries(dataItem.vehicles).forEach(([vehicleBundleId, vehicleArray]) => {
            vehicleArray.forEach((vehicle) => {
              // Skip warning vehicles
              const isWarning = vehicle.vehicleStatus && vehicle.vehicleStatus.toLowerCase().includes("warning");
              if (isWarning) {
                return;
              }

              // Get all enabled materials for this vehicle that match the line type AND workTicketId
              const enabledMaterials = vehicle.materialMapping.filter((material) => {
                const isEnabled = material.enabled !== false;
                const materialLineType = material.lineType;
                const shouldIncludeLineType =
                  lineType === null ? materialLineType === "Fulfill" || !materialLineType || materialLineType === "" : materialLineType === lineType;
                const shouldIncludeWorkTicketId = (material.workTicketId ?? null) === (workTicketId ?? null);
                return isEnabled && shouldIncludeLineType && shouldIncludeWorkTicketId;
              });

              if (enabledMaterials.length === 0) {
                return;
              }

              // Check if ANY material in this vehicle has zero ATP
              let hasAnyZeroATP = false;
              let hasAnyATP = false;

              for (const material of enabledMaterials) {
                const materialId = material.hardwareId;
                if (zeroAtpMaterialIds.has(materialId)) {
                  hasAnyZeroATP = true;
                }
                if (atpMaterialIds.has(materialId)) {
                  hasAnyATP = true;
                }
              }

              // Create vehicle object for API payload
              const vehiclePayload = {
                id: vehicle.id,
                vinStatus: vehicle.vehicleStatus,
                type: vehicle.deviceType,
                vinMaterials: enabledMaterials.map((material) => material.id).join(", "),
              };

              // If any material has zero ATP, entire vehicle goes to backorder
              if (hasAnyZeroATP) {
                backorderGroupVins.push({
                  ...vehiclePayload,
                  groupType: "Backorder",
                });
              } else if (hasAnyATP) {
                // Only if ALL materials have ATP > 0, vehicle goes to created group
                createdGroupVins.push({
                  ...vehiclePayload,
                  groupType: "Created",
                });
              }
            });
          });
        });
      }
    });

    return {
      createdGroupVins,
      backorderGroupVins,
    };
  };

  return (
    <>
      <div>
        {/* Work Tickets Success Modal */}
        <WorkTicketsSuccessModal show={showWTModal} workTicketNumbers={wtSuccessNumbers} onClose={() => setShowWTModal(false)} />
        {/* No Slots Available Dialog */}
        <NoSlotsAvailableModal
          show={showNoSlotsDialog}
          onClose={() => setShowNoSlotsDialog(false)}
          onConfirm={() => {
            setShowNoSlotsDialog(false);
            navigateToManualSchedule(noSlotsJobDataRef.current);
          }}
        />
        {isWTA && <OrderShippingSummaryAccordion></OrderShippingSummaryAccordion>}
        {spinner && (
          <div css={customSpinner}>
            <CircularProgressbar
              value={spinnerValue}
              text={`${spinnerValue}%`}
              styles={{ path: { stroke: spinnerValue > 49 ? `green` : `orange` } }}
            />
          </div>
        )}
        <FlexRow style={{ width: "auto", marginTop: "10px" }}>
          <FlexColumn style={{ width: "100%" }}>
            <FlexRow>
              <Button
                role="button"
                size="small"
                aria-label="Create Work Ticket for Valid Vehicles or Assets"
                onClick={handleCreateWorkTicketforAll}
                disabled={createWorkTicketValidVehiclesOrAssetsButtonStatus === false}
              >
                Create Work Ticket for Valid Vehicles or Assets
              </Button>

              <IconWrapper
                tabIndex={updatedVehicles.filter((v) => v.readyVehicles > 0).length > 1 ? 1 : -1}
                onClick={() =>
                  updatedVehicles.filter((v) => v.readyVehicles > 0).length > 1 && getWTTransactionStatus(orderNumber, transactionId || "")
                }
                style={{
                  pointerEvents: updatedVehicles.filter((v) => v.readyVehicles > 0).length > 1 ? "auto" : "none",
                  opacity: updatedVehicles.filter((v) => v.readyVehicles > 0).length > 1 ? 1 : 0.4,
                }}
              >
                <i name="refresh" className="pi pi-refresh" style={{ color: "var(--primary-color)", padding: "1px", marginLeft: "10px" }}></i>
              </IconWrapper>
            </FlexRow>
            <Spacer bottom="1rem" />
            <FlexRow>
              {createWorkTicketProgress && (
                <SLNotification
                  key={generate()}
                  title="Currently create work ticket is in progress"
                  type={"info"}
                  fullBleed={true}
                  css={CustomisedNotification}
                  hideCloseButton={false}
                />
              )}
              <Loader active={loader} fullscreen={false} />
              {isDataLoaded && !createWorkTicketProgress && (
                <WTACreateWorkTicketGrid
                  rows={updatedVehicles}
                  columns={CREATE_WORK_TICKET_LIST_COLS}
                  updatedVehicles={updatedVehicles}
                  setUpdatedVehicles={setUpdatedVehicles}
                  bundleCount={bundleCount}
                  createWorkTicketProgress={createWorkTicketProgress}
                  handleViewButtonClick={handleViewButtonClick}
                  handleCreateButtonClick={(bundleIds, addressId, contactId, lineType, reason, splitData, flag, workTicketId) =>
                    handleCreateButtonClick(bundleIds, addressId, contactId, lineType, reason, splitData, flag, workTicketId, selectedDeliveryDate)
                  }
                />
              )}
            </FlexRow>
          </FlexColumn>
        </FlexRow>
      </div>
    </>
  );
};
export default CreateWorkticket;

export const CreateWorkticketMetadata = {
  name: "CreateWorkticket",
  id: "create_workticket",
  component: lazy(() => import("./CreateWorkticket")),
  route: "/create_workticket",
};
